<template>
  <f7-page name="control-cifras-oeb" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link back icon-f7="arrow_left"></f7-link>
        <div class="btn-info" @click.stop="popupInfo = !popupInfo; if (popupInfo && !instrucciones.length) inicializarInst()" :class="{'btn-info-activo': popupInfo}"><span>i</span></div>
      </f7-nav-left>
      <f7-nav-title>Control de cifras OEB — Producción</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="zoomOut" style="font-size:12px;min-width:20px">−</f7-link>
        <span style="font-size:11px;min-width:30px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoomIn" style="font-size:12px;min-width:20px">+</f7-link>
        <f7-link icon-f7="arrow_2_circlepath" @click="actualizarCifras" title="Actualizar cifras"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · La pantalla se sirve de oeb_produccion_cache; "Recalcular" reescribe su calculadoEn.
         #26 · Y las CIFRAS que van dentro de la ficha tienen su propia antiguedad, distinta de la
         del recalculo: entran por "Actualizar cifras" y por el cron de 30 minutos. Son dos fechas
         y se enseñan las dos, porque una cache recien recalculada puede llevar cifras de hace
         dias. Sin marca —ficha anterior a #26, que no se rellena hacia atras— SelloDatos se
         degrada a "no se sabe" en vez de inventar una fecha.
         Mientras carga no se enseña ninguna de las dos: al recargar el mismo mes la ficha y su
         calculadoEn se conservan hasta que responde la peticion (#769), y lo que se esta
         recalculando es justo esa antiguedad. -->
    <div class="sello-datos-bar">
      <template v-if="!cargando">
        <sello-datos estado="fecha" :fecha="calculadoEn" />
        <sello-datos estado="fecha" :fecha="ficha && ficha.cifrasTpcCargadasEn" nota="Cifras TPC" />
      </template>
    </div>

    <f7-page-content style="padding-top:0">
      <div class="contenido-oea" :style="{ fontSize: (zoom * 0.12) + 'px' }">
      <!-- SELECTOR DE MES -->
      <div class="mes-selector">
        <f7-link @click="mesPrevio" icon-f7="chevron_left"></f7-link>
        <select v-model="anio" @change="cargarFicha" class="select-anio">
          <option v-for="a in aniosDisponibles" :key="a" :value="a">{{ a }}</option>
        </select>
        <select v-model="mes" @change="cargarFicha" class="select-mes">
          <option v-for="(nombre, idx) in nombresMeses" :key="idx" :value="idx + 1">{{ nombre }}</option>
        </select>
        <span class="mes-badge" :class="'badge-' + (ficha ? ficha.estado : '')">
          {{ ficha ? ficha.estado : '' }}
        </span>
        <f7-link @click="mesSiguiente" icon-f7="chevron_right"></f7-link>
      </div>

      <!-- MÉTRICAS GLOBALES -->
      <div class="metricas-grid" v-if="ficha && ficha.totales">
        <div class="metrica-card">
          <div class="metrica-label">Progresión total <info-icon dominio="oeb" clave="OEB_PROGRESION" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div>
          <div class="metrica-valor">{{ formatImporte(ficha.totales.progresionTotal) }}</div>
        </div>
        <div class="metrica-card">
          <div class="metrica-label">Objetivo mes <info-icon dominio="oeb" clave="OEB_ObjetivoMes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div>
          <div class="metrica-valor">{{ formatImporte(ficha.totales.objetivoMensualTotal) }}</div>
        </div>
        <div class="metrica-card">
          <div class="metrica-label">Falta para llegar <info-icon dominio="oeb" clave="OEB_FaltaTotal" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div>
          <div class="metrica-valor" :class="ficha.totales.faltaTotal >= 0 ? 'valor-positivo' : 'valor-negativo'">
            {{ formatImporteConSigno(ficha.totales.faltaTotal) }}
          </div>
        </div>
        <div class="metrica-card">
          <div class="metrica-label">% cumplimiento <info-icon dominio="oeb" clave="OEB_PctCumplimiento" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div>
          <div class="metrica-valor" :class="'color-' + calcularEstadoColor(ficha.totales.porcentajeGlobal)">
            {{ formatPorcentaje(ficha.totales.porcentajeGlobal) }}
          </div>
        </div>
      </div>

      <!-- INFO ACTUALIZACIÓN -->
      <div class="info-actualizacion" v-if="ficha">
        <span>Última actualización: {{ formatFecha(ficha.modificationDate) }}</span>
        <span> · Cada 30 min</span>
      </div>

      <!-- BOTONES DE ACCIÓN -->
      <!-- #85 · Desaparecen mientras se carga. Con `v-if="ficha"` la botonera del mes viejo quedaba
           activa debajo del selector del mes nuevo; desde la #769 la ficha se tira al cambiar de
           mes, pero al recargar el mismo se conserva y está a punto de ser sustituida. Las propias
           acciones lo comprueban además por su cuenta, que es lo que vale para el popup de la
           persona, que sí se queda abierto. -->
      <div class="acciones-bar" v-if="ficha && !cargando">
        <f7-button small fill color="green" @click="crearMesSiguiente" v-roles="['ADMIN','DIRECTOR','DTYCAL']">+ Crear {{ nombreMesSiguiente }}</f7-button>
        <!-- #34 · Guardar y + Persona solo para Administrador y Director. DTYCAL y PLANIFICACION
             siguen entrando a la pantalla, pero solo a mirar: no ven estos botones. -->
        <f7-button small fill color="blue" @click="guardarPersonasVisibles" :disabled="guardandoPersonas" v-roles="['ADMIN','DIRECTOR']">{{ guardandoPersonas ? 'Guardando...' : 'Guardar' }}</f7-button>
        <f7-button small outline @click="agregarPersona" v-roles="['ADMIN','DIRECTOR']">+ Persona</f7-button>
        <f7-button small outline @click="enviarReporte" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Enviar reporte</f7-button>
        <f7-button small outline @click="irANotificaciones" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Programar envíos</f7-button>
      </div>

      <!-- INDICADORES GLOBALES (11 KPIs) -->
      <div class="indicadores-grid" v-if="ficha && ficha.personas">
        <div class="ind-card ind-gris"><div class="ind-label">Personas <info-icon dominio="oeb" clave="OEB_Personas" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ ficha.personas.length }}</div></div>
        <div class="ind-card ind-gris"><div class="ind-label">D&iacute;as h&aacute;biles <info-icon dominio="oeb" clave="OEB_DH" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalDH }}</div></div>
        <div class="ind-card ind-amarillo"><div class="ind-label">Fiestas <info-icon dominio="oeb" clave="OEB_Fiestas" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalFiestas }}</div></div>
        <div class="ind-card ind-amarillo"><div class="ind-label">Vacaciones <info-icon dominio="oeb" clave="OEB_VAC" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalVacaciones }}</div></div>
        <div class="ind-card ind-rojo"><div class="ind-label">Bajas laborales <info-icon dominio="oeb" clave="OEB_BL" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalBajas }}</div></div>
        <div class="ind-card ind-gris"><div class="ind-label">D&iacute;as reales <info-icon dominio="oeb" clave="OEB_DR" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalDR }}</div></div>
        <div class="ind-card ind-gris"><div class="ind-label">N&ordm; I/C mes <info-icon dominio="oeb" clave="OEB_NumIC_Mes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalNumIc.toFixed(1) }}</div></div>
        <div class="ind-card ind-azul"><div class="ind-label">N&ordm; horas mes <info-icon dominio="oeb" clave="OEB_NumHIC_Mes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalHorasMes }}</div></div>
        <div class="ind-card ind-azul"><div class="ind-label">Precio medio/h <info-icon dominio="oeb" clave="OEB_PrecioMedioICH_Mes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indPrecioMedioHora }} &euro;</div></div>
        <div class="ind-card ind-amarillo"><div class="ind-label">Horas comp. <info-icon dominio="oeb" clave="OEB_CO" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ indTotalCompensacion }}</div></div>
        <div class="ind-card ind-azul"><div class="ind-label">Productividad I/C <info-icon dominio="oeb" clave="OEB_ProdIc_Mes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></div><div class="ind-val">{{ formatImporteCorto(indProductividadIc) }}</div></div>
      </div>

      <!-- TABLA PRINCIPAL — Estructura idéntica al Excel -->
      <div class="tabla-container" v-if="ficha && ficha.personas && ficha.personas.length > 0">
        <div class="tabla-scroll">
          <table class="tabla-oea">
            <thead>
              <tr>
                <th class="col-sticky col-codigo">Cód.</th>
                <!-- Bloque 2: Producción semanal -->
                <th class="col-sem col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'hc-'+sem.numero">
                  S{{ sem.numero }}<br><span class="sem-fechas">{{ extraerDias(sem) }}</span>
                </th>
                <!-- Bloque 3: Resumen -->
                <th class="col-progresion col-sep-left">Progr. <info-icon dominio="oeb" clave="OEB_PROGRESION" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-num">Obj.Mes <info-icon dominio="oeb" clave="OEB_ObjetivoMes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-num">Falta <info-icon dominio="oeb" clave="OEB_FaltaTotal" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-pct">% <info-icon dominio="oeb" clave="OEB_PctCumplimiento" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <!-- Bloque 4: Días -->
                <th class="col-dia col-sep-left">D.H <info-icon dominio="oeb" clave="OEB_DH" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-dia">Vac <info-icon dominio="oeb" clave="OEB_VAC" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-dia">BL <info-icon dominio="oeb" clave="OEB_BL" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-dia">Comp. <info-icon dominio="oeb" clave="OEB_CO" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-dia">D.R <info-icon dominio="oeb" clave="OEB_DR" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <!-- Bloque 5: Días por semana -->
                <th class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'hd-'+sem.numero">
                  S{{ sem.numero }}
                </th>
                <!-- Bloque 6: Obj diario -->
                <th class="col-num col-sep-left" style="text-align:center">T.DÍA <info-icon dominio="oeb" clave="OEB_TDIA" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-num" style="text-align:center">H.D. <info-icon dominio="oeb" clave="OEB_HD" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-num" style="text-align:center">Nº I/C <info-icon dominio="oeb" clave="OEB_NumIC" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-num" style="text-align:center">Prod/<br>día <info-icon dominio="oeb" clave="OEB_ProdDia_Mes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <th class="col-num" style="text-align:center">Prod/<br>h <info-icon dominio="oeb" clave="OEB_ProdH_Mes" criticidad="CRITICO" pantalla="control-cifras-oeb" /></th>
                <!-- Bloque 7: Objetivo semanal -->
                <th class="col-sem col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'ho-'+sem.numero">
                  S{{ sem.numero }}
                </th>
                <!-- Bloque 8: Total -->
                <th class="col-num col-sep-left">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="persona in personasOrdenadas" :key="persona.codigoPersonal"
                  @click="abrirDetallePersona(persona)" class="fila-persona">
                <td class="col-sticky col-codigo"><strong>{{ persona.codigoPersonal }}</strong></td>
                <!-- Bloque 2: Producción semanal -->
                <td class="col-sem col-sep-left" v-for="(resultado, idx) in persona.resultadosSemana" :key="'rc-'+idx"
                    :style="colorCeldaSemana(persona, idx)">
                  {{ resultado > 0 ? formatImporteCorto(resultado) : '—' }}
                </td>
                <!-- Bloque 3: Resumen -->
                <td class="col-progresion col-sep-left" :style="colorProgresionMensual(persona)"><strong>{{ formatImporteCorto(persona.progresionMes) }}</strong></td>
                <td class="col-num">{{ formatImporteCorto(persona.objetivoMensual) }}</td>
                <td class="col-num" :class="persona.faltaParaLlegar >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  {{ formatImporteConSigno(persona.faltaParaLlegar) }}
                </td>
                <td class="col-pct">
                  <span class="badge-estado" :class="'estado-' + persona.estadoColor">{{ formatPorcentaje(persona.porcentajeCumplimiento) }}</span>
                </td>
                <!-- Bloque 4: Días -->
                <td class="col-dia col-sep-left">{{ calcularDiasHabilesPersona(persona) }}</td>
                <td class="col-dia" :class="{'dia-ausencia': persona.diasVacaciones > 0}">{{ persona.diasVacaciones || 0 }}</td>
                <td class="col-dia" :class="{'dia-baja': getDesgloseBL(persona.codigoPersonal) > 0}">{{ getDesgloseBL(persona.codigoPersonal) }}</td>
                <td class="col-dia" :class="{'dia-comp': getCompensacionPersona(persona.codigoPersonal) > 0}">{{ getCompensacionPersona(persona.codigoPersonal) > 0 ? getCompensacionPersona(persona.codigoPersonal).toFixed(1) : '' }}</td>
                <td class="col-dia">{{ persona.diasReales || 0 }}</td>
                <!-- Bloque 5: Días reales por semana -->
                <td class="col-dia col-sep-left" v-for="(sem, idx) in persona.semanas" :key="'ds-'+idx"
                    :class="[sem.modificado ? 'dia-modificado' : getColorDiaSemana(persona.codigoPersonal, idx)]">
                  {{ getDiasRealesSem(persona.codigoPersonal, idx) }}
                </td>
                <!-- Bloque 6: Obj diario + H.D. + Nº I/C + Prod/día + Prod/h (todos read-only) -->
                <td class="col-num col-sep-left" style="text-align:right">{{ formatImporteCorto(persona.objetivoDiarioActual) }}</td>
                <td class="col-num" style="text-align:center">{{ getHorasDiarias(persona.codigoPersonal) }}</td>
                <td class="col-num" style="text-align:center">{{ getNumIc(persona.codigoPersonal) }}</td>
                <td class="col-num" style="text-align:right">{{ persona.diasReales > 0 ? Math.round(sumaTpcPersona(persona.codigoPersonal) / persona.diasReales) : '' }}</td>
                <td class="col-num" style="text-align:right">{{ getProdHora(persona.codigoPersonal) || '' }}</td>
                <!-- Bloque 7: Objetivo semanal -->
                <td class="col-sem col-sep-left" v-for="(obj, idx) in persona.objetivosSemana" :key="'os-'+idx">
                  {{ formatImporteCorto(obj) }}
                </td>
                <!-- Bloque 8: Total -->
                <td class="col-num col-sep-left">{{ formatImporteCorto(persona.objetivoMensual) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <!-- Fila TOTAL -->
              <tr class="fila-totales">
                <td class="col-sticky col-codigo"><strong>TOTAL</strong></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'tc-'+semT.semanaNumero">
                  <strong>{{ formatImporteCorto(semT.resultadoSemana) }}</strong>
                </td>
                <td class="col-progresion col-sep-left"><strong>{{ formatImporteCorto(ficha.totales.progresionTotal) }}</strong></td>
                <td class="col-num"><strong>{{ formatImporteCorto(ficha.totales.objetivoMensualTotal) }}</strong></td>
                <td class="col-num" :class="ficha.totales.faltaTotal >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  <strong>{{ formatImporteConSigno(ficha.totales.faltaTotal) }}</strong>
                </td>
                <td class="col-pct">
                  <span class="badge-estado" :class="'estado-' + calcularEstadoColor(ficha.totales.porcentajeGlobal)">{{ formatPorcentaje(ficha.totales.porcentajeGlobal) }}</span>
                </td>
                <td class="col-dia col-sep-left"><strong>{{ totalesDias.diasHabiles }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.vacaciones || 0 }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.bajas || 0 }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.compensacion > 0 ? totalesDias.compensacion.toFixed(1) : '' }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.diasReales }}</strong></td>
                <td class="col-dia col-sep-left" v-for="(sem, idx) in ficha.calendario.semanas" :key="'td-'+sem.numero">
                  <strong>{{ totalesDiasSemana[idx] }}</strong>
                </td>
                <td colspan="5" class="col-sep-left"></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'to-'+semT.semanaNumero">
                  <strong>{{ formatImporteCorto(semT.objetivoSemana) }}</strong>
                </td>
                <td class="col-num col-sep-left"><strong>{{ formatImporteCorto(ficha.totales.objetivoMensualTotal) }}</strong></td>
              </tr>
              <!-- Fila OBJ.SEM -->
              <tr class="fila-obj-sem">
                <td class="col-sticky col-codigo">OBJ.SEM <info-icon dominio="oeb" clave="OEB_ObjetivoSemanal" criticidad="CRITICO" pantalla="control-cifras-oeb" /></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'os2-'+semT.semanaNumero">
                  {{ formatImporteCorto(semT.objetivoSemana) }}
                </td>
                <td class="col-progresion col-sep-left">{{ formatImporteCorto(ficha.totales.objetivoMensualTotal) }}</td>
                <td colspan="3"></td>
                <td colspan="5" class="col-sep-left"></td>
                <td class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'od-'+sem.numero"></td>
                <td colspan="5" class="col-sep-left"></td>
                <td class="col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'oo-'+sem.numero"></td>
                <td class="col-sep-left"></td>
              </tr>
              <!-- Fila FALTA -->
              <tr class="fila-dif-sem">
                <td class="col-sticky col-codigo">FALTA <info-icon dominio="oeb" clave="OEB_FaltaTotal" criticidad="CRITICO" pantalla="control-cifras-oeb" /></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'fs-'+semT.semanaNumero"
                    :class="semT.diferencia >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  {{ formatImporteConSigno(semT.diferencia) }}
                </td>
                <td class="col-progresion col-sep-left" :class="ficha.totales.faltaTotal >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  {{ formatImporteConSigno(ficha.totales.faltaTotal) }}
                </td>
                <td colspan="3"></td>
                <td colspan="5" class="col-sep-left"></td>
                <td class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'fd-'+sem.numero"></td>
                <td colspan="5" class="col-sep-left"></td>
                <td class="col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'fo-'+sem.numero"></td>
                <td class="col-sep-left"></td>
              </tr>
              <!-- Fila % OBJ -->
              <tr class="fila-pct-sem">
                <td class="col-sticky col-codigo">% OBJ <info-icon dominio="oeb" clave="OEB_PctCumplimiento" criticidad="CRITICO" pantalla="control-cifras-oeb" /></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'ps2-'+semT.semanaNumero">
                  <span class="badge-estado" :class="'estado-' + calcularEstadoColor(semT.porcentaje)">{{ formatPorcentaje(semT.porcentaje) }}</span>
                </td>
                <td class="col-progresion col-sep-left">
                  <span class="badge-estado" :class="'estado-' + calcularEstadoColor(ficha.totales.porcentajeGlobal)">{{ formatPorcentaje(ficha.totales.porcentajeGlobal) }}</span>
                </td>
                <td colspan="3"></td>
                <td colspan="5" class="col-sep-left"></td>
                <td class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'pd-'+sem.numero"></td>
                <td colspan="5" class="col-sep-left"></td>
                <td class="col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'po-'+sem.numero"></td>
                <td class="col-sep-left"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <!-- LEYENDA DE COLORES -->
      <div class="leyenda" v-if="ficha">
        <span class="leyenda-item"><span class="dot estado-MUY_BUENO"></span> Muy bueno &gt;105% <info-icon dominio="oeb" clave="OEB_EstadoCumplimiento" criticidad="CRITICO" pantalla="control-cifras-oeb" /></span>
        <span class="leyenda-item"><span class="dot estado-BUENO"></span> Bueno 100-105%</span>
        <span class="leyenda-item"><span class="dot estado-MALO"></span> Malo 95-100%</span>
        <span class="leyenda-item"><span class="dot estado-MUY_MALO"></span> Muy malo &lt;95%</span>
      </div>


      <!-- LA CARGA NO HA IDO BIEN -->
      <!-- #80 · Un 500 de la API, un mes que de verdad no tiene ficha y una ficha a medias se veían
           exactamente igual: «No hay ficha» y el botón de crearla, que en los dos primeros casos no
           arregla nada. Si la carga falla o se pasa del plazo se dice, y el aviso lleva el
           Reintentar que ahorra salir y volver a entrar en la pantalla. -->
      <f7-block v-if="errorCarga && !cargando" class="text-align-center aviso-carga">
        <p class="aviso-carga-texto">
          &#9888; {{ errorCarga === 'TIEMPO'
            ? 'La ficha de ' + nombreMes + ' ' + anio + ' ha tardado demasiado y no se ha podido cargar.'
            : 'La ficha de ' + nombreMes + ' ' + anio + ' ha dado un error al cargarse.' }}
          <br>No quiere decir que no haya datos: v&uacute;elvelo a intentar.
        </p>
        <f7-button fill color="blue" @click="cargarFicha">Reintentar</f7-button>
      </f7-block>

      <!-- MENSAJE SI NO HAY FICHA -->
      <f7-block v-if="!ficha && !cargando && !errorCarga" class="text-align-center">
        <p>No hay ficha para {{ nombreMes }} {{ anio }}</p>
        <f7-button fill color="green" @click="crearFichaMes" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Crear ficha de {{ nombreMes }} {{ anio }}</f7-button>
      </f7-block>

      <!-- LOADING -->
      <f7-block v-if="cargando" class="text-align-center">
        <f7-preloader></f7-preloader>
        <p>Cargando datos...</p>
      </f7-block>
      </div>
    </f7-page-content>

    <!-- POPUP DETALLE PERSONA -->
    <f7-popup :opened="popupAbierto" @popup:closed="popupAbierto = false" class="popup-persona">
      <f7-page v-if="personaSel" :page-content="true">
        <f7-navbar title="">
          <f7-nav-right>
            <f7-link popup-close icon-f7="xmark"></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div style="text-align:center;padding:12px 0 4px;font-size:18px;font-weight:700;color:#1a2744">{{ personaSel.codigoPersonal }}</div>
        <f7-block-title>Objetivo diario</f7-block-title>
        <f7-block strong>
          <div style="display:flex;align-items:center;gap:8px">
            <input type="number" v-model.number="objetivoEditable" step="1" min="0" style="width:100px;padding:6px 8px;border:1px solid #ddd;border-radius:6px;font-size:15px;font-weight:500;text-align:right" />
            <span style="font-size:13px;color:#888">€/día</span>
            <button style="padding:6px 14px;background:#0F6E56;color:white;border:none;border-radius:6px;font-size:12px;cursor:pointer" @click="guardarObjetivo(personaSel)" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">Guardar</button>
          </div>
          <div style="margin-top:6px;font-size:12px;color:#888">Objetivo mensual: <strong>{{ formatImporte(calcularObjMensual()) }}</strong></div>
        </f7-block>
        <f7-block-title>Días hábiles por semana</f7-block-title>
        <f7-block strong>
          <table style="width:100%;border-collapse:collapse;font-size:12px">
            <thead>
              <tr>
                <th style="padding:4px;text-align:left;font-size:11px;color:#888;border-bottom:1px solid #ddd">Semana</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Días</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Orig.</th>
                <th style="padding:4px;text-align:right;font-size:11px;color:#888;border-bottom:1px solid #ddd">Obj.sem</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Estado</th>
                <th style="padding:4px;border-bottom:1px solid #ddd"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sem, idx) in personaSel.semanas" :key="'pd-'+sem.semanaNumero"
                  :class="{'fila-ausencia': (sem.diasReales != null ? sem.diasReales : sem.diasHabiles) < sem.diasHabilesOriginal}"
                  style="border-bottom:1px solid #f0f0f0">
                <td style="padding:4px"><strong>S{{ sem.semanaNumero }}</strong> <span style="font-size:10px;color:#aaa">{{ obtenerRangoSemana(sem.semanaNumero) }}</span></td>
                <td style="padding:4px;text-align:center"><strong>{{ sem.diasReales != null ? sem.diasReales : sem.diasHabiles }}</strong></td>
                <td style="padding:4px;text-align:center;color:#aaa">{{ sem.diasHabilesOriginal }}</td>
                <td style="padding:4px;text-align:right">{{ formatImporteCorto(personaSel.objetivosSemana && personaSel.objetivosSemana[idx] != null ? personaSel.objetivosSemana[idx] : personaSel.objetivoDiarioActual * (sem.diasReales != null ? sem.diasReales : sem.diasHabiles)) }}</td>
                <td style="padding:4px;text-align:center">
                  <span v-if="sem.modificado" style="background:#FAEEDA;color:#633806;font-size:10px;padding:2px 6px;border-radius:8px;cursor:pointer" @click="verNotaDias(sem)">Modificado</span>
                  <span v-else-if="(sem.diasReales != null ? sem.diasReales : sem.diasHabiles) < sem.diasHabilesOriginal" style="background:#FFF3CD;color:#856404;font-size:10px;padding:2px 6px;border-radius:8px">Ausencia</span>
                  <span v-else style="color:#aaa;font-size:10px">OK</span>
                </td>
                <td style="padding:4px"><button style="padding:2px 8px;border:1px solid #ddd;border-radius:4px;background:white;font-size:10px;cursor:pointer" @click="editarDiaSemana(sem)" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">Editar</button></td>
              </tr>
            </tbody>
          </table>
        </f7-block>
        <f7-block-title>Resumen del mes</f7-block-title>
        <f7-block strong>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">
            <div><span style="font-size:11px;color:#888;display:block">Progresión</span><span style="font-size:16px;font-weight:500">{{ formatImporte(personaSel.progresionMes) }}</span></div>
            <div><span style="font-size:11px;color:#888;display:block">Objetivo</span><span style="font-size:16px;font-weight:500">{{ formatImporte(personaSel.objetivoMensual) }}</span></div>
            <div><span style="font-size:11px;color:#888;display:block">Falta</span><span style="font-size:16px;font-weight:500" :class="personaSel.faltaParaLlegar>=0?'valor-positivo':'valor-negativo'">{{ formatImporteConSigno(personaSel.faltaParaLlegar) }}</span></div>
            <div><span style="font-size:11px;color:#888;display:block">Cumplimiento</span><span class="badge-estado" :class="'estado-'+personaSel.estadoColor">{{ formatPorcentaje(personaSel.porcentajeCumplimiento) }}</span></div>
          </div>
        </f7-block>
        <template v-if="ausencias[personaSel.codigoPersonal] && ausencias[personaSel.codigoPersonal].length">
          <f7-block-title>Ausencias detectadas</f7-block-title>
          <f7-block strong style="background:#FFFDE7">
            <table style="width:100%;border-collapse:collapse;font-size:12px">
              <thead>
                <tr>
                  <th style="padding:4px;text-align:left;font-size:11px;color:#888;border-bottom:1px solid #e0d8a8">Semana</th>
                  <th style="padding:4px;text-align:left;font-size:11px;color:#888;border-bottom:1px solid #e0d8a8">Fecha</th>
                  <th style="padding:4px;text-align:left;font-size:11px;color:#888;border-bottom:1px solid #e0d8a8">Motivo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(aus, ai) in ausencias[personaSel.codigoPersonal]" :key="'aus-'+ai" style="border-bottom:1px solid #f0eca0">
                  <td style="padding:4px"><strong>S{{ getSemanaParaDia(aus.dia) }}</strong></td>
                  <td style="padding:4px">{{ diaSemanaLabel(aus.dia) }} {{ aus.dia }}/{{ mes }}/{{ anio }}</td>
                  <td style="padding:4px;color:#e6a817;font-weight:600">{{ aus.motivo }}</td>
                </tr>
              </tbody>
            </table>
          </f7-block>
        </template>
        <f7-block-title v-if="historialPersona.length>0">Historial de cambios</f7-block-title>
        <f7-block strong v-if="historialPersona.length>0">
          <table style="width:100%;border-collapse:collapse;font-size:10px;table-layout:fixed">
            <thead><tr><th style="padding:3px;text-align:left;color:#888;border-bottom:1px solid #ddd;width:60px">Persona</th><th style="padding:3px;text-align:left;color:#888;border-bottom:1px solid #ddd;width:65px">Fecha</th><th style="padding:3px;text-align:left;color:#888;border-bottom:1px solid #ddd;width:120px">Campo</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd;width:70px">Anterior</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd;width:70px">Nuevo</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd;width:60px">Usuario</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd">Motivo</th></tr></thead>
            <tbody><tr v-for="(c,i) in historialPersona" :key="'h-'+i" style="border-bottom:1px solid #f0f0f0"><td style="padding:3px">{{ personaSel.codigoPersonal }}</td><td style="padding:3px">{{ c.fecha ? new Date(c.fecha).toLocaleDateString('es-ES') : '' }}</td><td style="padding:3px">{{ c.campo }}</td><td style="padding:3px">{{ c.valorAnterior }}</td><td style="padding:3px">{{ c.valorNuevo }}</td><td style="padding:3px">{{ c.usuario }}</td><td style="padding:3px">{{ c.motivo || '' }}</td></tr></tbody>
          </table>
        </f7-block>
        <!-- #34 · Mismo rol que + Persona. No borra sus cifras del mes: deja de verse. -->
        <f7-block><f7-button fill color="red" @click="quitarPersona(personaSel)" v-roles="['ADMIN','DIRECTOR']">Quitar del mes</f7-button></f7-block>
      </f7-page>
    </f7-popup>

    <!-- POPUP GUÍA DE USO -->
    <f7-popup :opened="popupInfo" @popup:close="fullscreen = false; popupInfo = false" class="ct-popup-guia" :style="fullscreen ? '--f7-popup-tablet-width:95vw;--f7-popup-tablet-height:95vh' : ''">
      <f7-page :page-content="false">
        <f7-navbar title="Guía de uso" style="display:none"></f7-navbar>
        <div class="ct-hdr" style="background:linear-gradient(135deg,#0F6E56,#27ae80)">
          <div class="ct-hdr-top">
            <div class="ct-hdr-left">
              <span class="ct-hdr-ico">📈</span>
              <div><div class="ct-hdr-title">Guía de uso</div><div class="ct-hdr-sub">CONTROL DE CIFRAS OEA</div></div>
            </div>
            <div class="ct-hdr-right">
              <span class="ct-hdr-badge">{{ instFiltradas.length }} instrucciones</span>
              <button class="ct-hdr-add" @click="nuevaInst">+</button>
              <button class="ct-hdr-close" @click="fullscreen = !fullscreen">{{ fullscreen ? '⇖' : '⛶' }}</button>
              <button class="ct-hdr-close" @click="fullscreen = false; popupInfo = false">✕</button>
            </div>
          </div>
          <div class="ct-search-wrap">
            <span class="ct-search-ico">🔍</span>
            <input class="ct-search" type="text" placeholder="Buscar instrucciones..." v-model="busquedaInst">
            <button v-if="busquedaInst" class="ct-search-x" @click="busquedaInst = ''">✕</button>
          </div>
        </div>
        <f7-page-content class="ct-body">
          <!-- #85 · Quién sale en «+ Persona» y quién pasa al mes nuevo, con las exclusiones que
               quedan a propósito. Va fijo en la pantalla y no como instrucción de base de datos
               porque describe lo que hace el código: si se pudiera editar o borrar, mañana diría
               otra cosa que la regla que se aplica de verdad. Mismo texto en OEB - Planificación,
               que comparte ficha, botón y criterio. -->
          <div class="ct-card ct-card-fija" style="border-left-color:#0F6E56">
            <div class="ct-card-hdr">
              <span class="ct-card-num" style="background:#0F6E56">i</span>
              <div class="ct-card-title-area"><div class="ct-card-title">Quién aparece en este mes y quién no</div></div>
            </div>
            <div class="ct-card-body">
              <div class="ct-card-content">
                <p><b>Regla única:</b> toda persona con el check Activo marcado en Configuración OEB del año de este mes puede añadirse a este mes, y al crear un mes nuevo pasan todas las del mes anterior que sigan activas en esa configuración.</p>
                <p><b>«+ Persona»</b> ofrece a todas las personas activas en la Configuración OEB del año de este mes, y solo deja fuera a las que ya se ven aquí. Quien se sacó con «Quitar del mes» sigue saliendo en la lista, marcado como «vuelve con sus cifras»: al añadirlo recupera su fila con los datos que tenía en el mes, no empieza de cero.</p>
                <p><b>«Crear ‹mes›»</b> monta el mes nuevo con las personas activas en la Configuración OEB del año de ESE mes. Los objetivos que se hubieran retocado a mano en el mes anterior se heredan; el resto sale del objetivo del año.</p>
                <p><b>Las únicas razones por las que alguien no aparece:</b></p>
                <ol>
                  <li>No tiene el check Activo marcado en Configuración OEB <b>del año de este mes</b>. Manda el año: estar activo en 2025 no mete a nadie en un mes de 2026. Y manda también sobre el trabajo del mes: si alguien tiene producción en el mes pero no está activo en la configuración del año, no entra, porque quitarle el check es una decisión y crear el mes no la deshace.</li>
                  <li>El mes anterior tenía la lista de personas guardada con «Guardar personas del mes» y esa persona no estaba en ella. El mes nuevo hereda esa lista a propósito, para no tener que repetir cada mes la decisión de quién se ve. Se resuelve añadiéndola con «+ Persona».</li>
                  <li>Ya se ve en este mes: nadie entra dos veces.</li>
                </ol>
                <p><b>Dos avisos más.</b> Si un año todavía no tiene ninguna persona activa en su Configuración OEB, se usa la lista general de personas —la que no va por años— para no dejar el mes vacío. Y el botón «Desactivar» de Configuración OEB actúa sobre esa lista general, no sobre el año: para que alguien deje de entrar en los meses de un año hay que desmarcar su check Activo en la Configuración OEB de ese año.</p>
                <p><b>Quien produce sin estar configurado.</b> Si en el trabajo del mes aparece alguien que no está en la Configuración OEB, al crear el mes se le da de alta automáticamente en la de ese año, con 12,72 € al día de objetivo provisional, y entra en el mes. No se queda invisible produciendo, y desde Configuración OEB se le puede poner su objetivo de verdad o darle de baja. A quien ya tiene el check Activo desmarcado en la configuración del año no se le da de alta: eso es una decisión tomada y crear el mes no la deshace.</p>
              </div>
            </div>
          </div>
          <div v-if="instFiltradas.length" class="ct-counter">{{ instFiltradas.length }} instrucciones</div>
          <div v-if="!instFiltradas.length" class="ct-empty"><span style="font-size:32px;opacity:.3">📈</span><p>Sin instrucciones. Pulsa + para crear.</p></div>
          <div v-for="(inst, idx) in instFiltradas" :key="inst.id" class="ct-card" style="border-left-color:#0F6E56"
            draggable="true" @dragstart="draggingInst = idx" @dragover.prevent @drop="dropInst(idx)">
            <div class="ct-card-hdr" @click="expandedInst === inst.id ? expandedInst = null : expandedInst = inst.id">
              <span class="ct-card-num" style="background:#0F6E56">{{ idx + 1 }}</span>
              <div class="ct-card-title-area"><div class="ct-card-title">{{ inst.titulo }}</div></div>
              <span class="ct-card-chev">{{ expandedInst === inst.id ? '▲' : '▼' }}</span>
            </div>
            <div v-if="expandedInst === inst.id" class="ct-card-body">
              <template v-if="inst._editando">
                <div class="ct-form-field"><label>Título</label><input type="text" v-model="inst.titulo"></div>
                <div class="ct-form-field"><label>Contenido</label><textarea v-model="inst.texto" rows="4"></textarea></div>
                <div class="ct-form-btns">
                  <button class="ct-fbtn ct-fbtn-ok" @click="guardarInst(inst)">Guardar</button>
                  <button class="ct-fbtn ct-fbtn-cancel" @click="inst._editando = false">Cancelar</button>
                </div>
              </template>
              <template v-else>
                <div class="ct-card-content">{{ inst.texto }}</div>
                <div class="ct-card-actions">
                  <button @click.stop="$set(inst, '_editando', true)">✏️ Editar</button>
                  <button @click.stop="eliminarInst(inst)">🗑️ Eliminar</button>
                </div>
              </template>
            </div>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>

    <!-- POPUP ENVIAR REPORTE -->
    <f7-popup :opened="popupReporte" @popup:closed="popupReporte = false" class="popup-reporte">
      <f7-page>
        <f7-navbar title="Enviar informe OEA">
          <f7-nav-right><f7-link popup-close icon-f7="xmark"></f7-link></f7-nav-right>
        </f7-navbar>
        <f7-page-content>
          <f7-block-title>Tipo de informe</f7-block-title>
          <f7-block strong>
            <div style="display:flex;gap:8px">
              <div @click="reporteTipo = 'DIARIO'; actualizarAsuntoReporte()" style="flex:1;padding:10px;text-align:center;border-radius:8px;cursor:pointer;font-size:12px;font-weight:600" :style="reporteTipo === 'DIARIO' ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)',color:'#1a2744'} : {border:'1px solid #ddd',color:'#64748b'}">
                <div>Diario</div><div style="font-size:10px;font-weight:400;margin-top:2px">Hoy + acumulado</div>
              </div>
              <div @click="reporteTipo = 'SEMANAL'; actualizarAsuntoReporte()" style="flex:1;padding:10px;text-align:center;border-radius:8px;cursor:pointer;font-size:12px;font-weight:600" :style="reporteTipo === 'SEMANAL' ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)',color:'#1a2744'} : {border:'1px solid #ddd',color:'#64748b'}">
                <div>Semanal</div><div style="font-size:10px;font-weight:400;margin-top:2px">Semana en curso</div>
              </div>
              <div @click="reporteTipo = 'MENSUAL'; actualizarAsuntoReporte()" style="flex:1;padding:10px;text-align:center;border-radius:8px;cursor:pointer;font-size:12px;font-weight:600" :style="reporteTipo === 'MENSUAL' ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)',color:'#1a2744'} : {border:'1px solid #ddd',color:'#64748b'}">
                <div>Mensual</div><div style="font-size:10px;font-weight:400;margin-top:2px">Mes completo</div>
              </div>
            </div>
          </f7-block>
          <f7-block-title>Destinatarios</f7-block-title>
          <f7-block strong>
            <div style="margin-bottom:8px">
              <label style="font-size:11px;font-weight:600;color:#64748b;display:block;margin-bottom:4px">Para (separados por coma):</label>
              <textarea v-model="reporteEmails" rows="2" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px;resize:vertical;box-sizing:border-box" placeholder="email1@empresa.com, email2@empresa.com"></textarea>
            </div>
            <div style="margin-bottom:8px">
              <label style="font-size:11px;font-weight:600;color:#64748b;display:block;margin-bottom:4px">CC (opcional):</label>
              <input v-model="reporteCc" type="text" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px;box-sizing:border-box" placeholder="cc@empresa.com">
            </div>
          </f7-block>
          <f7-block-title>Asunto</f7-block-title>
          <f7-block strong>
            <input v-model="reporteAsunto" type="text" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px;box-sizing:border-box">
          </f7-block>
          <!-- Desde la #15 el envio recalcula los datos antes de generar el correo, asi que puede
               tardar hasta un minuto. Se dice en el boton: si solo pusiera "Enviando..." pareceria
               colgado y quien lo mira acabaria volviendo a pulsar. -->
          <f7-block>
            <f7-button fill color="green" @click="confirmarEnvioReporte" :disabled="enviandoReporte">
              {{ enviandoReporte ? 'Recalculando y enviando...' : 'Enviar informe' }}
            </f7-button>
          </f7-block>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
/* Popup persona */
.popup-persona { --f7-popup-tablet-width: 480px; }
.popup-reporte { --f7-popup-tablet-width: 500px; }

/* Zoom container */
.contenido-oea { font-size: 10px; }

/* Selector de mes */
.mes-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8em;
  padding: 0.3em 0.6em 0.2em;
}
.select-anio, .select-mes { font-size: 1.2em; font-weight: 600; padding: 0.2em 0.4em; border: 1px solid #ddd; border-radius: 0.3em; background: white; color: #1a2744; text-align: center; }
.select-anio { min-width: 5em; }
.select-mes { min-width: 8em; }
.mes-badge {
  display: inline-block;
  font-size: 0.7em;
  padding: 0.2em 0.8em;
  border-radius: 2em;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.badge-activo { background: #E8F5E9; color: #2E7D32; }
.badge-cerrado { background: #ECEFF1; color: #546E7A; }
.badge-borrador { background: #FFF3E0; color: #E65100; }

/* Métricas */
.metricas-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.4em;
  padding: 0 0.6em 0.3em;
}
@media (max-width: 600px) {
  .metricas-grid { grid-template-columns: repeat(2, 1fr); }
}
.metrica-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafe 100%);
  border: 1px solid #e8edf3;
  border-radius: 0.5em;
  padding: 0.4em 0.6em;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}
.metrica-label {
  font-size: 0.65em;
  color: #7c8db0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 600;
  margin-bottom: 0.1em;
}
.metrica-valor { font-size: 1.2em; font-weight: 700; color: #1a2744; letter-spacing: -0.02em; }

/* Info actualización */
.info-actualizacion { padding: 0 0.6em 0.2em; font-size: 0.65em; color: #9aa5b8; letter-spacing: 0.02em; }

/* Botones acción */
.acciones-bar { display: flex; gap: 0.4em; padding: 0 0.6em 0.3em; flex-wrap: wrap; }
.acciones-bar .button { font-size: 0.75em; font-weight: 600; letter-spacing: 0.03em; border-radius: 0.5em; padding: 0.3em 0.8em; }

/* Tabla principal — Executive Dashboard */
.tabla-container { padding: 0 0.4em; }
.tabla-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #dde3ed;
  border-radius: 0.8em;
  margin: 0 0.6em;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  background: white;
}
.tabla-oea { border-collapse: collapse; font-size: 1em; white-space: nowrap; width: 100%; }
.tabla-oea thead th {
  background: #1a2744;
  color: #c8d3e5;
  padding: 0.5em 0.4em;
  font-weight: 600;
  font-size: 0.85em;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: none;
  text-align: right;
  position: sticky;
  top: 0;
  z-index: 2;
}
.tabla-oea thead th.col-codigo { text-align: left; color: white; }
.tabla-oea tbody tr { transition: background 0.15s; }
.tabla-oea tbody tr:nth-child(even) { background: #fafbfd; }
.tabla-oea tbody tr:hover { background: #eef2f9 !important; }
.tabla-oea tbody td {
  padding: 0.35em 0.4em;
  border-bottom: 1px solid #eef0f5;
  text-align: right;
  font-size: 0.95em;
  color: #2d3748;
}
.tabla-oea tbody td.col-codigo { text-align: left; font-weight: 700; color: #1a2744; letter-spacing: 0.02em; min-width: 5em; }

/* Sticky column */
.col-sticky { position: sticky; left: 0; background: white; z-index: 1; box-shadow: 2px 0 8px rgba(0,0,0,0.06); }
thead .col-sticky { background: #1a2744; z-index: 3; }
.fila-totales .col-sticky, .fila-obj-sem .col-sticky, .fila-dif-sem .col-sticky, .fila-pct-sem .col-sticky { background: #eef1f7; }

/* Column types */
.col-sem { min-width: 4.8em; }
.col-num { min-width: 5em; }
.col-dia { min-width: 2em; text-align: center !important; font-size: 0.85em; color: #7c8db0; }
.col-pct { min-width: 4.5em; text-align: center !important; }
.col-progresion { font-weight: 700; min-width: 5.5em; }

/* Separators */
.col-sep-left { border-left: 2px solid #c8d0de !important; }
thead .col-sep-left { border-left: 2px solid #3d5278 !important; }

/* Special states */
.dia-modificado { background: #fff3cd !important; font-weight: bold; }
.dia-ausencia { background:#FFF9E6 !important; color:#856404; font-weight:600; }
.dia-baja { background:#FEE2E2 !important; color:#991B1B; font-weight:600; }
.dia-comp { background:#EDE9FE !important; color:#5B21B6; font-weight:600; }
.fila-persona { cursor: pointer; }
.sem-fechas { font-size: 0.8em; color: #7c8db0; }

/* Footer rows */
.fila-totales td { background: #eef1f7; font-weight: 700; padding: 0.45em 0.4em; border-top: 2px solid #c8d0de; color: #1a2744; font-size: 1em; text-align: right; }
.tabla-oea tfoot td { text-align: right; }
.fila-obj-sem td { background: #f5f7fa; font-size: 0.85em; color: #7c8db0; padding: 0.25em 0.4em; font-weight: 500; }
.fila-dif-sem td { font-size: 0.85em; padding: 0.25em 0.4em; font-weight: 500; }
.fila-pct-sem td { font-size: 0.85em; padding: 0.25em 0.4em; border-bottom: 2px solid #c8d0de; }

/* Badges clasificación */
.badge-cls {
  display: inline-block;
  padding: 0.1em 0.6em;
  border-radius: 0.4em;
  font-weight: 700;
  font-size: 0.85em;
  letter-spacing: 0.03em;
}


.badge-IC { background: #EDE7F6; color: #4527A0; border: 1px solid #B39DDB; }

/* Badges estado */
.badge-estado {
  display: inline-block;
  padding: 0.15em 0.6em;
  border-radius: 2em;
  font-weight: 700;
  font-size: 0.85em;
  letter-spacing: 0.02em;
}
.estado-MUY_BUENO { background: #D6EAF8; color: #1B4F72; }
.estado-BUENO { background: #D5F5E3; color: #0E6251; }
.estado-MALO { background: #FADBD8; color: #943126; }
.estado-MUY_MALO { background: #F1948A; color: #641E16; }

/* Colores métricas */
.color-MUY_BUENO { color: #1B4F72; }
.color-BUENO { color: #0E6251; }
.color-MALO { color: #943126; }
.color-MUY_MALO { color: #B71C1C; }

/* Valores */
.valor-positivo { color: #0E6251 !important; font-weight: 600; }
.valor-negativo { color: #B71C1C !important; font-weight: 600; }

/* Leyenda */
.leyenda { padding: 0.6em 0.8em; display: flex; gap: 1.2em; flex-wrap: wrap; font-size: 0.8em; color: #7c8db0; }
.leyenda-item { display: flex; align-items: center; gap: 0.4em; }
.dot { display: inline-block; width: 1em; height: 1em; border-radius: 50%; }
.dot.estado-MUY_BUENO { background: #D6EAF8; border: 1px solid #1B4F72; }
.dot.estado-BUENO { background: #D5F5E3; border: 1px solid #0E6251; }
.dot.estado-MALO { background: #FADBD8; border: 1px solid #943126; }
.dot.estado-MUY_MALO { background: #F1948A; border: 1px solid #641E16; }

/* Aviso de carga fallida (#80) — mismos colores que la pantalla de Planificación */
.aviso-carga { background: #FDECEA; border: 1px solid #F5A29B; border-radius: 0.6em; }
.aviso-carga-texto { color: #8A1C13; font-weight: 600; }

/* Tabla resumen por clasificación */

.tabla-resumen-cls {
  width: 100%;
  max-width: 650px;
  border-collapse: collapse;
  font-size: 1em;
  border: 1px solid #dde3ed;
  border-radius: 0.8em;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
.tabla-resumen-cls thead tr { background: #1a2744; }
.tabla-resumen-cls th {
  padding: 0.6em 0.8em;
  text-align: right;
  font-weight: 600;
  font-size: 0.85em;
  color: #c8d3e5;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.tabla-resumen-cls th:first-child { text-align: left; }
.tabla-resumen-cls td { padding: 0.6em 0.8em; text-align: right; border-bottom: 1px solid #eef0f5; font-size: 0.95em; }
.tabla-resumen-cls td:first-child { text-align: left; }
.tabla-resumen-cls .fila-totales td { background: #eef1f7; font-weight: 700; border-top: 2px solid #c8d0de; }

/* Tabla historial */
.tabla-historial { width: 100%; border-collapse: collapse; font-size: 1.1em; }
.tabla-historial th { padding: 0.4em 0.6em; background: #f5f5f5; text-align: left; font-weight: 500; font-size: 1em; color: #7c8db0; border-bottom: 1px solid #ddd; }
.tabla-historial td { padding: 0.4em 0.6em; border-bottom: 1px solid #f0f0f0; font-size: 1em; }

/* Botón info + Popup guía */
.btn-info { width:24px;height:24px;border-radius:50%;background:rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;cursor:pointer;border:1.5px solid #5DCAA5; }
.btn-info span { color:#5DCAA5;font-size:13px;font-weight:500;font-style:italic; }
.btn-info-activo { background:#5DCAA5 !important; }
.btn-info-activo span { color:#1a2744 !important; }
.ct-popup-guia { --f7-popup-tablet-width:700px; }
.ct-hdr { padding:14px 16px 12px;flex-shrink:0; }
.ct-hdr-top { display:flex;justify-content:space-between;align-items:center;margin-bottom:12px; }
.ct-hdr-left { display:flex;align-items:center;gap:10px; }
.ct-hdr-ico { font-size:24px; }
.ct-hdr-title { font-size:16px;font-weight:800;color:#fff; }
.ct-hdr-sub { font-size:10px;color:rgba(255,255,255,.6);margin-top:1px; }
.ct-hdr-right { display:flex;align-items:center;gap:6px; }
.ct-hdr-badge { background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff; }
.ct-hdr-add,.ct-hdr-close { width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center; }
.ct-hdr-add:hover,.ct-hdr-close:hover { background:rgba(255,255,255,.25); }
.ct-search-wrap { position:relative;display:flex;align-items:center; }
.ct-search-ico { position:absolute;left:10px;font-size:13px; }
.ct-search { width:100%;padding:9px 32px;border:none;border-radius:8px;font-size:13px;background:rgba(255,255,255,.9);color:#1e293b;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.1); }
.ct-search:focus { background:#fff; }
.ct-search-x { position:absolute;right:8px;background:none;border:none;color:#94a3b8;font-size:12px;cursor:pointer;padding:4px; }
.ct-body { background:linear-gradient(180deg,#f8fafc,#f0f2f5);padding:10px 14px !important; }
.ct-counter { font-size:11px;color:#64748b;font-weight:600;padding:4px 2px 8px; }
.ct-empty { text-align:center;padding:40px 20px;color:#94a3b8;font-size:12px; }
.ct-card { background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.05);overflow:hidden;cursor:grab; }
.ct-card:hover { box-shadow:0 3px 10px rgba(0,0,0,.08); }
.ct-card-hdr { display:flex;align-items:center;gap:10px;padding:10px 12px;cursor:pointer; }
.ct-card-num { width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;color:#fff;flex-shrink:0; }
.ct-card-title-area { flex:1;min-width:0; }
.ct-card-title { font-size:13px;font-weight:600;color:#1e293b;line-height:1.4; }
.ct-card-chev { font-size:10px;color:#94a3b8;flex-shrink:0; }
.ct-card-body { padding:0 12px 12px;border-top:1px solid #f1f5f9; }
.ct-card-content { font-size:12.5px;line-height:1.6;color:#334155;padding:10px 4px; }
/* #85 · La tarjeta fija de «quién aparece en este mes»: ni se arrastra ni se pliega, así que no
   hereda el cursor de arrastre de .ct-card ni el de pulsar de la cabecera. */
.ct-card-fija { cursor:default; }
.ct-card-fija .ct-card-hdr { cursor:default; }
.ct-card-fija .ct-card-content p { margin:0 0 8px; }
.ct-card-fija .ct-card-content p:last-child { margin-bottom:0; }
.ct-card-fija .ct-card-content ol { margin:0 0 8px;padding-left:18px; }
.ct-card-fija .ct-card-content li { margin-bottom:4px; }
.ct-card-actions { display:flex;gap:4px;padding-top:8px;border-top:1px solid #f1f5f9; }
.ct-card-actions button { background:none;border:1px solid #e2e8f0;border-radius:6px;padding:4px 10px;font-size:10px;cursor:pointer;color:#475569; }
.ct-card-actions button:hover { background:#f1f5f9; }
.ct-form-field { display:flex;flex-direction:column;gap:3px;margin-bottom:8px; }
.ct-form-field label { font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase; }
.ct-form-field input,.ct-form-field textarea { padding:8px 10px;border:1.5px solid #d1d9e0;border-radius:6px;font-size:12px;font-family:inherit;color:#1e293b;outline:none;resize:vertical; }
.ct-form-field input:focus,.ct-form-field textarea:focus { border-color:#0F6E56; }
.ct-form-btns { display:flex;gap:6px; }
.ct-fbtn { padding:7px 16px;border:none;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit; }
.ct-fbtn-ok { background:#0F6E56;color:#fff; }
.ct-fbtn-ok:hover { background:#0a4f42; }
.ct-fbtn-cancel { background:#f1f5f9;color:#475569;border:1px solid #e2e8f0; }
.ct-fbtn-cancel:hover { background:#e2e8f0; }
/* === Indicadores globales (11 KPIs superior) — copia de Planificacion === */
.indicadores-grid { display:grid; grid-template-columns:repeat(11,1fr); gap:0.4em; padding:0.3em 0.6em; }
@media (max-width:900px) { .indicadores-grid { grid-template-columns:repeat(4,1fr); } }
@media (max-width:500px) { .indicadores-grid { grid-template-columns:repeat(2,1fr); } }
.ind-card { border-radius:0.5em; padding:0.35em 0.5em; text-align:center; }
.ind-label { font-size:10px; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; opacity:0.7; margin-bottom:0.1em; }
.ind-val { font-size:16px; font-weight:500; }
.ind-gris { background:#f0f4fa; color:#1a2744; }
.ind-amarillo { background:#FFF9E6; color:#856404; }
.ind-rojo { background:#FEE2E2; color:#991B1B; }
.ind-azul { background:#E6F1FB; color:#0C447C; }
.fila-ausencia { background:#FFF9E6; }
</style>
<style>
.popup-persona .navbar .left { display: none !important; }
.popup-persona .navbar .left a { display: none !important; }
.popup-persona .navbar .title-large { display: none !important; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
/* #26 · Con alto reservado: los sellos se ocultan mientras carga y sin esto la pantalla daba un
   salto cada vez que se cambiaba de mes. */
.sello-datos-bar { padding: 6px 16px 0; min-height: 30px; display: flex; flex-wrap: wrap; gap: 8px; }
</style>
<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import avisoNoGuardado from '../../js/utils/avisoNoGuardado.js';
import Oeb from '../../js/db/Oeb.js';
import InfoIcon from '../../components/InfoIcon.vue';
import SelloDatos from '../../components/SelloDatos.vue';
import carrilPeticiones from '../../js/utils/carrilPeticiones.js';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';

// #80 · Plazo propio de la pantalla para la ficha del mes, el mismo que la pantalla hermana de
// Planificación (#46). Sin él, una petición que no vuelve nunca —corte de red, pasarela colgada—
// deja el preloader girando para siempre y nadie sabe qué ha pasado. Holgado a propósito: una
// carga lenta pero viva de este cuadro de mandos ronda el minuto.
var ESPERA_FICHA_MS = 120000;

// #769 · El plazo de la ficha como un fallo más de la petición: así lo decide el carril igual que
// un 500 —limpia y avisa si es la vigente, y si ya no lo es no toca nada— y no hace falta un reloj
// que apague el «cargando» por su cuenta. La petición no se puede abortar; solo se deja de esperar.
// El mismo que en OEB - Planificación.
function conPlazo(promesa, ms) {
  let reloj;
  const vencido = new Promise(function(_, rechazar) {
    reloj = setTimeout(function() { rechazar({ plazoVencido: true }); }, ms);
  });
  return Promise.race([promesa, vencido]).then(
    function(res) { clearTimeout(reloj); return res; },
    function(err) { clearTimeout(reloj); throw err; });
}

export default {
  components: { InfoIcon, SelloDatos },
  // #769 · La ficha del mes, las acciones que la recargan y su «cargando» van por el carril común
  // de la #472: tira el mes de antes en cuanto se pide otro —antes se quedaba debajo del selector
  // nuevo hasta que contestaba el servidor— y solo apaga el «cargando» la respuesta vigente.
  // Recargar el MISMO mes («Actualizar cifras», guardar) no vacía: ahí las cifras son las de hace
  // un segundo y vaciarlas sería un parpadeo.
  created() {
    const self = this;
    self.carrilFicha = carrilPeticiones({
      deAhora: function() { return [self.anio, self.mes]; },
      vaciar: function() { self.vaciarFicha(); },
      cargando: function(si) { self.cargando = si; }
    });
  },
  // Lo que conteste ya no tiene a quién avisar si nadie está mirando la pantalla.
  beforeDestroy() {
    this.carrilFicha.invalidar();
  },
  data() {
    return {
      anio: new Date().getFullYear(),
      mes: new Date().getMonth() + 1,
      ficha: null,
      calculadoEn: null,
      cargando: false,
      // #80 · null | 'ERROR' | 'TIEMPO'. Con null, el hueco sin ficha es el de siempre —el mes no
      // tiene ficha creada y se ofrece crearla—; con valor, la carga no ha ido bien y se avisa.
      errorCarga: null,
      zoom: 100,
      historialConfig: [],
      personaSel: null,
      popupAbierto: false,
      guardandoPersonas: false,
      objetivoEditable: 0,
      vacacionesEditable: 0,
      popupReporte: false,
      reporteTipo: 'MENSUAL',
      reporteEmails: '',
      reporteCc: '',
      reporteAsunto: '',
      enviandoReporte: false,
      popupInfo: false,
      fullscreen: false,
      instrucciones: [],
      busquedaInst: '',
      expandedInst: null,
      draggingInst: null,
      desglose: {},
      ausencias: {},
      compensacionData: {},
      numIcData: {},
      horasDiariasData: {},
    };
  },
  computed: {
    // === KPIs SUPERIORES (copia literal de Planificación) ===
    indTotalDH: function() {
      if (!this.ficha || !this.ficha.personas) return 0;
      var self = this;
      return this.ficha.personas.reduce(function(s, p) { return s + self.calcularDiasHabilesPersona(p); }, 0);
    },
    indTotalVacaciones: function() {
      if (!this.ficha || !this.ficha.personas) return 0;
      return this.ficha.personas.reduce(function(s, p) { return s + (p.diasVacaciones || 0); }, 0);
    },
    indTotalBajas: function() {
      if (!this.ficha || !this.ficha.personas || !this.desglose) return 0;
      var self = this;
      return this.ficha.personas.reduce(function(s, p) { return s + self.getDesgloseBL(p.codigoPersonal); }, 0);
    },
    indTotalFiestas: function() {
      if (!this.ausencias) return 0;
      var total = 0;
      for (var cod in this.ausencias) {
        var aus = this.ausencias[cod];
        for (var i = 0; i < aus.length; i++) {
          if (aus[i].motivo && aus[i].motivo.toLowerCase().indexOf('fiesta') > -1) total++;
        }
      }
      return total;
    },
    indTotalDR: function() {
      if (!this.ficha || !this.ficha.personas) return 0;
      return this.ficha.personas.reduce(function(s, p) { return s + (p.diasReales || 0); }, 0);
    },
    indTotalNumIc: function() {
      if (!this.ficha || !this.ficha.personas) return 0;
      var self = this;
      return this.ficha.personas.reduce(function(s, p) { return s + self.getNumIc(p.codigoPersonal); }, 0);
    },
    indTotalTpc: function() {
      if (!this.ficha || !this.ficha.personas) return 0;
      var self = this; var t = 0;
      self.ficha.personas.forEach(function(p) { t += self.sumaTpcPersona(p.codigoPersonal); });
      return t;
    },
    indAvgHD: function() {
      if (!this.ficha || !this.ficha.personas || !this.ficha.personas.length) return 8;
      var self = this;
      return this.ficha.personas.reduce(function(s, p) { return s + self.getHorasDiarias(p.codigoPersonal); }, 0) / self.ficha.personas.length;
    },
    indTotalHorasMes: function() {
      if (!this.ficha || !this.ficha.personas) return 0;
      var self = this; var total = 0;
      self.ficha.personas.forEach(function(p) { total += self.getHorasDiarias(p.codigoPersonal) * (p.diasReales || 0); });
      return Math.round(total);
    },
    indPrecioMedioHora: function() {
      if (this.indTotalHorasMes <= 0) return '0,0';
      return (this.indTotalTpc / this.indTotalHorasMes).toFixed(1).replace('.', ',');
    },
    indTotalCompensacion: function() {
      if (!this.compensacionData) return 0;
      var total = 0;
      for (var cod in this.compensacionData) total += this.compensacionData[cod];
      return Math.round(total);
    },
    indProductividadIc: function() {
      if (!this.ficha || !this.ficha.personas || this.indTotalNumIc <= 0) return 0;
      var self = this;
      var tpcTotal = 0;
      self.ficha.personas.forEach(function(p) { tpcTotal += self.sumaTpcPersona(p.codigoPersonal); });
      return tpcTotal / self.indTotalNumIc;
    },
    instFiltradas() {
      var q = (this.busquedaInst || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) { return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1; });
    },
    nombresMeses() {
      return ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    },
    aniosDisponibles() {
      var arr = [];
      for (var a = 2007; a <= new Date().getFullYear() + 1; a++) arr.push(a);
      return arr;
    },
    nombreMes() {
      var meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      return meses[this.mes] || '';
    },
    nombreMesSiguiente() {
      var m = this.mes === 12 ? 1 : this.mes + 1;
      var a = this.mes === 12 ? this.anio + 1 : this.anio;
      var meses = ['','Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      return meses[m] + ' ' + a;
    },
    personasOrdenadas() {
      if (!this.ficha || !this.ficha.personas) return [];
      
      return [...this.ficha.personas].sort(function(a, b) {
        return a.codigoPersonal.localeCompare(b.codigoPersonal);
      });
    },
    // Fila TOTAL, bloque de días: se suma sobre personasOrdenadas —las filas que se están
    // pintando— para que el total refleje lo que se ve si hay filtros. Aquí no hay columna FIES.
    totalesDias() {
      var self = this;
      var t = { diasHabiles: 0, vacaciones: 0, bajas: 0, compensacion: 0, diasReales: 0 };
      this.personasOrdenadas.forEach(function(p) {
        t.diasHabiles += self.calcularDiasHabilesPersona(p) || 0;
        t.vacaciones += p.diasVacaciones || 0;
        t.bajas += self.getDesgloseBL(p.codigoPersonal) || 0;
        t.compensacion += self.getCompensacionPersona(p.codigoPersonal) || 0;
        t.diasReales += p.diasReales || 0;
      });
      // Comp. va en horas y admite decimal: mismo redondeo que las celdas de arriba
      t.compensacion = Math.round(t.compensacion * 10) / 10;
      return t;
    },
    // Días por semana del bloque de días: cuadran por posición, igual que el tbody.
    totalesDiasSemana() {
      if (!this.ficha || !this.ficha.calendario || !this.ficha.calendario.semanas) return [];
      var self = this;
      var personas = this.personasOrdenadas;
      return this.ficha.calendario.semanas.map(function(sem, idx) {
        return personas.reduce(function(sum, p) {
          return sum + (self.getDiasRealesSem(p.codigoPersonal, idx) || 0);
        }, 0);
      });
    },
    resumenPorClasificacion() {
      if (!this.ficha || !this.ficha.personas) return [];
      var grupos = {};
      var totalProgresion = this.ficha.totales ? this.ficha.totales.progresionTotal : 0;
      this.ficha.personas.forEach(function(p) {
        var cls = p.clasificacion || 'I/C';
        if (!grupos[cls]) {
          grupos[cls] = { clasificacion: cls, totalResultado: 0, totalObjetivo: 0 };
        }
        grupos[cls].totalResultado += (p.progresionMes || 0);
        grupos[cls].totalObjetivo += (p.objetivoMensual || 0);
      });
      var orden = ['GC', 'FV', 'I/C'];
      return orden.map(function(cls) {
        var g = grupos[cls] || { clasificacion: cls, totalResultado: 0, totalObjetivo: 0 };
        g.diferencia = g.totalResultado - g.totalObjetivo;
        g.porcentaje = g.totalObjetivo > 0 ? (g.totalResultado / g.totalObjetivo) * 100 : 0;
        g.porcentajeTotal = totalProgresion > 0 ? Math.round(g.totalResultado / totalProgresion * 100) : 0;
        return g;
      }).filter(function(g) { return g.totalResultado > 0 || g.totalObjetivo > 0; });
    },
    historialPersona() {
      var cambios = [];
      if (this.personaSel && this.personaSel.semanas) {
        this.personaSel.semanas.forEach(function(sem) {
          if (sem.modificado && sem.modificacion) {
            cambios.push({
              fecha: sem.modificacion.fecha,
              campo: 'Días S' + sem.semanaNumero,
              valorAnterior: sem.modificacion.diasAnterior + ' días',
              valorNuevo: sem.modificacion.diasNuevo + ' días',
              usuario: sem.modificacion.usuario,
              motivo: sem.modificacion.motivo
            });
          }
        });
      }
      if (this.historialConfig && this.historialConfig.length > 0) {
        this.historialConfig.forEach(function(c) { cambios.push(c); });
      }
      cambios.sort(function(a, b) { return new Date(b.fecha) - new Date(a.fecha); });
      return cambios;
    }
  },
  methods: {
    zoomIn() { this.zoom = Math.min(150, this.zoom + 5); },
    zoomOut() { this.zoom = Math.max(40, this.zoom - 5); },
    onPageInit() {
      var guardadoAnio = localStorage.getItem('oeb_ultimo_anio');
      var guardadoMes = localStorage.getItem('oeb_ultimo_mes');
      if (guardadoAnio) this.anio = parseInt(guardadoAnio);
      if (guardadoMes) this.mes = parseInt(guardadoMes);
      this.cargarFicha();
      this.cargarInstrucciones();
    },
    cargarFicha(force) {
      force = force === true;
      localStorage.setItem('oeb_ultimo_anio', this.anio);
      localStorage.setItem('oeb_ultimo_mes', this.mes);
      var self = this;
      // #85 · La lista de «+ Persona» que estuviera abierta es del mes de antes.
      self.cerrarListaPersonas();
      // #80 · Solo la carga vigente escribe en la pantalla. Cambiar de mes y el botón Reintentar
      // pueden dejar una petición anterior en vuelo, y la que llega tarde no puede pisar lo que ya
      // se está viendo ni resucitar un aviso que ya no toca. Eso, y tirar el mes anterior al pedir
      // otro, lo decide el carril (#769).
      var promise = force
        ? Oeb.recalcularProduccion(self.anio, self.mes)
        : Oeb.getFichaProduccion(self.anio, self.mes);
      self.errorCarga = null;
      self.carrilFicha.lanzar(conPlazo(promise, ESPERA_FICHA_MS), {
        exito: function(res) {
          var datos = unwrapDto(res);
          if (datos && datos.ficha) {
            self.ficha = datos.ficha;
            self.calculadoEn = datos.calculadoEn || null;
            self.desglose = datos.desglose || {};
            self.ausencias = datos.ausencias || {};
            self.compensacionData = datos.compensacion || {};
            self.numIcData = datos.numIc || {};
            self.horasDiariasData = datos.horasDiarias || {};
          } else {
            self.vaciarFicha();
            // #80 · Una respuesta sin ficha son dos cosas distintas y no se pueden contar igual:
            // «este mes no tiene ficha todavía» es normal y tiene su bloque con el botón de
            // crearla; cualquier otro motivo es un fallo de carga y hay que avisar. La API lo dice
            // en `sinFicha` (NO_CREADA / INCOMPLETA / DESCONOCIDO). Si no viene —API sin el cambio
            // de esta misma tarea desplegado— se mantiene lo de antes y no se inventa un error.
            self.errorCarga = (datos && datos.sinFicha && datos.sinFicha !== 'NO_CREADA') ? 'ERROR' : null;
          }
        },
        limpiar: function() { self.vaciarFicha(); },
        // Se distingue la petición cortada sin respuesta —plazo o pasarela, que no significa que
        // no haya datos— del resto de fallos, que es donde cae el 500 de la caché duplicada.
        fallo: function(err) {
          self.errorCarga = (err && err.plazoVencido) || Oeb.esResultadoIncierto(err) ? 'TIEMPO' : 'ERROR';
        }
      });
    },
    // #80 · Deja la pantalla sin nada que pintar. Único sitio donde se borra, para que los tres
    // finales malos de la carga (sin ficha, fallo y plazo vencido) no se separen con el tiempo.
    vaciarFicha() {
      this.ficha = null;
      this.calculadoEn = null;
      this.desglose = {};
      this.ausencias = {};
      this.compensacionData = {};
      this.numIcData = {};
      this.horasDiariasData = {};
    },
    // #85 · Con qué mes se ARRANCA algo, o `null` si ahora mismo no hay ninguno del que fiarse.
    // Además de que la ficha y el selector cuadren, exige que no haya otra carga en vuelo: la
    // acción que empieza ahora no puede apoyarse en una ficha que está a punto de ser sustituida,
    // y la botonera tampoco se ve mientras carga.
    //
    // Para lo que ocurre DESPUÉS —una respuesta que llega, un diálogo que se confirma— la pregunta
    // no es esta sino `esElMismoMes`.
    refFicha() {
      if (this.cargando) return null;
      return this.mesEnPantalla();
    },
    sigueEnLaFicha(ref) {
      return this.mismaRef(ref, this.refFicha());
    },
    // #85 · Qué mes hay debajo, se esté cargando algo o no. Una referencia que mezcle el id de un
    // mes con el año y el mes de otro mandaba «+ Persona», Guardar, Quitar o los días al mes
    // anterior. Desde la #769 el carril tira la ficha en cuanto se pide otro mes, así que esa
    // mezcla ya no se pinta; la comprobación se queda porque es lo que protege a las acciones cuya
    // respuesta llega después, y lo que la delata —que el id y el selector dejen de coincidir— se
    // ve aquí sin mirar `cargando`.
    //
    // El año y el mes se cogen de la ficha cargada y no del selector: es el servidor quien dice de
    // qué mes es lo que se está pintando. Mismo criterio en OEB - Planificación.
    mesEnPantalla() {
      if (!this.ficha || !this.ficha.id) return null;
      // La comparación solo se hace si la ficha trae su mes: una API sin este dato no puede dejar
      // la pantalla entera sin botones.
      if (this.ficha.anio != null && this.ficha.mes != null
          && (this.ficha.anio !== this.anio || this.ficha.mes !== this.mes)) return null;
      return { id: this.ficha.id, anio: this.anio, mes: this.mes };
    },
    mismaRef(ref, actual) {
      return !!ref && !!actual && actual.id === ref.id
        && actual.anio === ref.anio && actual.mes === ref.mes;
    },
    // #85 · Se sigue en el MISMO mes, aunque haya otra carga de ese mes en vuelo. Para después de
    // una petición, `cargando` no responde a la pregunta que toca: dice si la pantalla está
    // ocupada, no si se ha cambiado de mes, y confundirlos descartaba respuestas del mes correcto.
    esElMismoMes(ref) {
      return this.mismaRef(ref, this.mesEnPantalla());
    },
    // #85 · Qué hacer con la respuesta de una acción que YA ha escrito en el servidor. `true` para
    // pintarla aquí mismo; `false` cuando no se puede, y entonces esto ya ha dejado encargado que
    // lo escrito acabe viéndose.
    //
    // El caso que lo pide: se pulsa «+ Persona» y, con el POST en vuelo, «Actualizar cifras» del
    // mismo mes. Ese GET tomó su foto ANTES de que el alta se escribiera, así que pintarlo deja la
    // pantalla diciendo que no se añadió a nadie. Se tira esa carga y se pide el mes otra vez
    // —`cargarFicha` anula la que estuviera en vuelo—, que es lo que sí trae lo recién escrito.
    // Si se ha cambiado de mes, no hay nada que pintar ni que recargar.
    aplicarResultado(ref) {
      if (this.sigueEnLaFicha(ref)) return true;
      if (this.esElMismoMes(ref)) this.cargarFicha();
      return false;
    },
    // Lo que no se hace porque la pantalla está cargando otro mes se dice, en vez de dejar el clic
    // sin respuesta.
    avisarFichaEnVuelo(titulo) {
      this.$f7.dialog.alert('La pantalla está cargando el mes que has elegido. Espera a que termine y vuelve a intentarlo.', titulo);
    },
    // La lista de «+ Persona» es de un mes concreto, así que al recargar se cierra en vez de
    // quedarse abierta encima del mes nuevo esperando a que alguien pulse y se lleve el rechazo.
    cerrarListaPersonas() {
      if (this._listaPersonas) this._listaPersonas.close();
    },
    mesPrevio() {
      if (this.mes === 1) { this.mes = 12; this.anio--; }
      else { this.mes--; }
      this.cargarFicha();
    },
    mesSiguiente() {
      if (this.mes === 12) { this.mes = 1; this.anio++; }
      else { this.mes++; }
      this.cargarFicha();
    },
    actualizarCifras() {
      var self = this;
      if (!self.ficha) return;
      // #80 · El refresco entra por el mismo testigo que la carga. Si mientras está en vuelo se
      // cambia de mes, manda la carga nueva y este final —salga bien o mal— ya no toca la pantalla:
      // si no, un refresco fallido del mes anterior apagaba el reloj del mes que se está cargando y
      // dejaba la ficha vieja debajo del selector nuevo como si fuera la suya.
      const nombre = self.nombreMes + ' ' + self.anio;
      // Si la actualización falla, el preloader se quedaba girando sin fin y sin decir nada. Aquí
      // no se pinta el aviso de carga: la ficha que se está viendo sigue siendo válida, lo que no
      // ha ido es el refresco.
      //
      // #164 · El aviso sale AUNQUE se haya cambiado de mes por el camino: lo que ha fallado es
      // una escritura que el usuario pidió, y callársela porque esta operación ya no manda es el
      // fallo silencioso que esta tarea viene a quitar. Por eso lleva el mes dentro —se puede
      // leer con otro mes delante— y sale también por `descartada`; el «cargando» sí es de quien
      // manda, y lo lleva el carril.
      const avisarFallo = function() {
        self.$f7.toast.create({ text: 'No se han podido actualizar las cifras de ' + nombre + '. Vuelve a intentarlo.', position: 'top', closeTimeout: 4000 }).open();
      };
      self.carrilFicha.lanzar(Oeb.actualizarCifras(self.anio, self.mes), {
        exito: function() { self.cargarFicha(true); },
        fallo: avisarFallo,
        descartada: function(ok) { if (!ok) avisarFallo(); }
      });
    },
    crearFichaMes() {
      var self = this;
      var meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      // #85 · El mes se fija al empezar. Son tres peticiones encadenadas y el selector se puede
      // mover por el camino: leyendo `self.anio`/`self.mes` en cada paso se acababa recalculando
      // y actualizando un mes distinto del que se acaba de crear.
      var anio = self.anio;
      var mes = self.mes;
      // #85 · La creación entra por el mismo testigo que la carga. Si mientras está en vuelo se
      // cambia de mes, manda la carga nueva y este final —salga bien o mal— ya no toca ni el
      // reloj ni la ficha: apagar `cargando` desde aquí sacaba la botonera encima del mes viejo
      // antes de que terminara la carga del nuevo.
      //
      // #769 · La ficha recién creada ya no se pinta a mitad de la cadena, con el recálculo todavía
      // en vuelo: se escribía por fuera del carril, que entonces no sabía que había algo que tirar,
      // y un cambio de mes en ese rato la dejaba debajo del selector nuevo. Se pinta al final,
      // con la recarga, que trae ya las cifras calculadas.
      var creada = false;
      const creacion = Oeb.crearFicha(anio, mes).then(function() {
        creada = true;
        return Oeb.recalcularFicha(anio, mes);
      }).then(function() {
        return Oeb.actualizarCifras(anio, mes);
      });
      // #164 · El fallo se avisa siempre; lo que depende de seguir mandando es si además se
      // puede tocar la pantalla. Ver `avisarCreacionFallida`.
      self.carrilFicha.lanzar(creacion, {
        exito: function() {
          self.$f7.toast.create({ text: 'Ficha de ' + meses[mes] + ' ' + anio + ' creada y actualizada', position: 'top', closeTimeout: 2000 }).open();
          self.cargarFicha();
        },
        fallo: function(err) { self.avisarCreacionFallida(err, creada, anio, mes, meses[mes] + ' ' + anio, true); },
        descartada: function(ok, err) {
          if (!ok) self.avisarCreacionFallida(err, creada, anio, mes, meses[mes] + ' ' + anio, false);
        }
      });
    },
    crearMesSiguiente() {
      var self = this;
      var mesNuevo = self.mes === 12 ? 1 : self.mes + 1;
      var anioNuevo = self.mes === 12 ? self.anio + 1 : self.anio;
      var meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      self.$f7.dialog.confirm('¿Crear ficha de ' + meses[mesNuevo] + ' ' + anioNuevo + '?', 'Crear mes', function() {
        // #85 · Por el mismo carril que la carga, por lo mismo que en `crearFichaMes`.
        var creada = false;
        const nombre = meses[mesNuevo] + ' ' + anioNuevo;
        const creacion = Oeb.crearFicha(anioNuevo, mesNuevo).then(function() {
          creada = true;
          return Oeb.recalcularFicha(anioNuevo, mesNuevo);
        }).then(function() {
          return Oeb.actualizarCifras(anioNuevo, mesNuevo);
        });
        self.carrilFicha.lanzar(creacion, {
          exito: function() {
            self.mes = mesNuevo;
            self.anio = anioNuevo;
            self.$f7.toast.create({ text: 'Ficha de ' + nombre + ' creada', position: 'top', closeTimeout: 2000 }).open();
            self.cargarFicha();
          },
          fallo: function(err) { self.avisarCreacionFallida(err, creada, anioNuevo, mesNuevo, nombre, true); },
          descartada: function(ok, err) {
            if (!ok) self.avisarCreacionFallida(err, creada, anioNuevo, mesNuevo, nombre, false);
          }
        });
      });
    },
    // #85 · Las tres peticiones de la creación caen en el mismo `catch`, pero solo la primera
    // decide si el mes existe: si `crearFicha` ya respondió bien, el servidor conserva la ficha
    // aunque falle el cálculo, y decir «No se ha creado el mes» invita a crearlo otra vez y a
    // llevarse el error de duplicado. Cuando la creación se confirmó —o se cortó sin respuesta, y
    // entonces no se sabe— se lleva el selector a ese mes y se recarga, que es lo único que
    // enseña si está o no. El reloj no se toca aquí (#769): lo apaga el carril cuando no queda
    // nada en vuelo, y si este final recarga, la recarga lo mantiene puesto. Mismo criterio en
    // OEB - Planificación.
    //
    // #164 · `manda` es si la operación sigue siendo la dueña de la pantalla. Si el usuario cambió
    // de mes mientras la creación viajaba, ya no lo es: el aviso SALE IGUAL —el mes quedó a medias
    // en el servidor y callarlo es justo lo que lleva al duplicado— pero no se le secuestra el
    // selector ni se le pisa la carga que acaba de arrancar, así que el texto le dice que entre él
    // al mes en vez de prometerle que se abre solo.
    avisarCreacionFallida(err, creada, anio, mes, nombre, manda) {
      if (!creada && !Oeb.esResultadoIncierto(err)) {
        this.$f7.dialog.alert('No se ha podido crear la ficha de ' + nombre + '. Vuelve a intentarlo.', 'No se ha creado el mes');
        return;
      }
      if (!manda) {
        this.$f7.dialog.alert(creada
          ? 'La ficha de ' + nombre + ' sí se ha creado, pero no se han podido calcular sus cifras. Entra en ese mes y usa «Actualizar cifras» para terminarla: no la crees otra vez.'
          : 'No se ha podido saber si la ficha de ' + nombre + ' llegó a crearse. Entra en ese mes para comprobarlo: si ya está, no la crees otra vez.',
          creada ? 'El mes se ha creado sin cifras' : 'Puede que el mes se haya creado');
        return;
      }
      this.anio = anio;
      this.mes = mes;
      this.$f7.dialog.alert(creada
        ? 'La ficha de ' + nombre + ' sí se ha creado, pero no se han podido calcular sus cifras. Se abre a continuación: no la crees otra vez, usa «Actualizar cifras» para terminarla.'
        : 'No se ha podido saber si la ficha de ' + nombre + ' llegó a crearse. Se abre a continuación para que lo compruebes: si ya está, no la crees otra vez.',
        creada ? 'El mes se ha creado sin cifras' : 'Puede que el mes se haya creado');
      this.cargarFicha();
    },
    getNombreMesSiguiente() {
      var m = this.mes === 12 ? 1 : this.mes + 1;
      var a = this.mes === 12 ? this.anio + 1 : this.anio;
      var meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      return meses[m] + ' ' + a;
    },
    // #34 · La persona tiene que existir ya en la Configuración OEB: desde aquí no se da de alta
    // a nadie.
    // #85 · Quién se ofrece lo decide el servidor: los activos en la Configuración OEB del AÑO de
    // este mes que todavía no se ven aquí. Esta pantalla y OEB - Planificación lo montaban cada una
    // por su lado cruzando la lista de personas —que no tiene año— con las filas pintadas, así que
    // el mismo criterio equivocado estaba escrito dos veces.
    // La lista se pide para UNA ficha concreta y solo vale para ella: el año y el mes se pueden
    // cambiar mientras llega la respuesta, y entonces lo que se pintaría es la gente de un mes
    // sobre el selector de otro. Por eso se guarda el mes con el que se pidió —ficha Y selector,
    // ver `refFicha`— y se comprueba al llegar, y otra vez al pulsar cada botón, que ocurre más
    // tarde todavía.
    agregarPersona() {
      var self = this;
      var ref = self.refFicha();
      if (!ref) return self.avisarFichaEnVuelo('No se ha añadido a nadie');
      var anioPedido = ref.anio;
      Oeb.getPersonasDisponiblesParaFicha(ref.id)
        .then(function(res) {
          if (!self.esElMismoMes(ref)) return;
          var disponibles = unwrapDto(res) || [];

          if (disponibles.length === 0) {
            self.$f7.dialog.alert('Todas las personas activas en la Configuración OEB de ' + anioPedido + ' ya están en esta pantalla. Para incorporar a alguien nuevo, primero hay que darle de alta en Configuración OEB de ' + anioPedido + '.', 'Sin personas que añadir');
            return;
          }

          var buttons = disponibles.map(function(p) {
            // «vuelve» y no «se añade»: tiene entrada en el mes porque se la quitaron, y al ponerla
            // otra vez recupera sus cifras en vez de empezar de cero (#34).
            return {
              text: p.codigoPersonal
                + (p.nombre && p.nombre !== p.codigoPersonal ? ' — ' + p.nombre : '')
                + (p.quitadaDelMes ? ' (vuelve con sus cifras)' : ''),
              onClick: function() { self.agregarPersonaCodigo(p.codigoPersonal, ref); }
            };
          });

          self.cerrarListaPersonas();
          self._listaPersonas = self.$f7.actions.create({
            buttons: [
              [{ text: 'Personas de la Configuración OEB ' + anioPedido, label: true }].concat(buttons),
              [{ text: 'Cancelar' }]
            ],
            on: {
              closed: function() {
                if (self._listaPersonas === this) self._listaPersonas = null;
                this.destroy();
              }
            }
          });
          self._listaPersonas.open();
        })
        .catch(function() {
          // El fallo también es del mes con el que se pidió la lista: si la pantalla ya está en
          // otro, el aviso hablaría de una petición que quien lo lee no ha hecho desde aquí.
          if (!self.esElMismoMes(ref)) return;
          self.$f7.dialog.alert('No se ha podido cargar la lista de personas de la Configuración OEB', 'Error');
        });
    },
    // Se recarga la ficha en vez de quedarse con la que devuelve el POST: la de la respuesta no
    // lleva el enriquecido (ausencias, días reales, objetivos) que pinta esta pantalla.
    //
    // `refEsperada` es el mes del que salió la lista: si la pantalla ya está en otro se rechaza en
    // vez de añadir a ciegas, que añadiría al mes anterior mientras el selector enseña el nuevo.
    agregarPersonaCodigo(codigo, refEsperada) {
      var self = this;
      if (!refEsperada || !self.esElMismoMes(refEsperada)) {
        self.$f7.dialog.alert('La pantalla ha cambiado de mes mientras la lista estaba abierta. Vuelve a pulsar «+ Persona».', 'No se ha añadido a nadie');
        return;
      }
      // El POST va al id de la referencia, no a `ficha.id`: es el mes del que salió la lista.
      Oeb.agregarPersonaAFicha(refEsperada.id, codigo)
        .then(function(res) {
          if (!self.esElMismoMes(refEsperada)) return;
          if (unwrapDto(res)) { self.cargarFicha(); }
          else { self.$f7.dialog.alert(res.message || 'Error', 'Error'); }
        })
        .catch(function() {
          if (!self.esElMismoMes(refEsperada)) return;
          self.$f7.dialog.alert('No se ha podido añadir a ' + codigo + ' a este mes', 'Error');
        });
    },
    // #34 · Fija para este mes la lista de personas que hay ahora en pantalla. A partir de aquí
    // la ve cualquier usuario que abra Control de cifras OEB —y OEB - Planificación, que comparte
    // ficha— en este mes, y el mes siguiente la hereda al crearse.
    //
    // La lista que se guarda es la del mes que se estaba mirando al pulsar, no la del que haya
    // cuando se confirme: entre una cosa y otra cabe un cambio de mes, y guardar entonces fijaría
    // en el mes nuevo las personas del anterior.
    guardarPersonasVisibles() {
      var self = this;
      if (!self.ficha || self.guardandoPersonas) return;
      var ref = self.refFicha();
      if (!ref) return self.avisarFichaEnVuelo('No se ha guardado');
      var codigos = (self.ficha.personas || []).map(function(p) { return p.codigoPersonal; });
      self.$f7.dialog.confirm(
        'Se fijan las ' + codigos.length + ' personas que se ven ahora para ' + self.nombreMes + ' ' + self.anio + '. Las verá así todo el mundo, también en OEB - Planificación. ¿Guardar?',
        'Guardar personas del mes',
        function() {
          if (!self.esElMismoMes(ref)) {
            self.$f7.dialog.alert('La pantalla ha cambiado de mes. No se ha guardado nada: vuelve a pulsar «Guardar personas del mes».', 'No se ha guardado');
            return;
          }
          // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que lo soltaba.
          cerrojoDeLaSesion(self, 'guardandoPersonas');
          Oeb.guardarPersonasVisibles(ref.id, codigos)
            .then(function() {
              self.guardandoPersonas = false;
              // El aviso y el refresco son del mes que se guardó. El texto del toast se arma con
              // `nombreMes`, que ya es el del selector nuevo: sin esta comprobación anunciaba
              // guardado un mes en el que no se ha tocado nada.
              if (!self.esElMismoMes(ref)) return;
              self.$f7.toast.create({ text: 'Personas de ' + self.nombreMes + ' guardadas', position: 'top', closeTimeout: 2000 }).open();
              self.cargarFicha();
            })
            .catch(function() {
              self.guardandoPersonas = false;
              if (!self.esElMismoMes(ref)) return;
              self.$f7.dialog.alert('No se han podido guardar las personas del mes', 'Error');
            });
        });
    },
    irANotificaciones() {
      this.$f7router.navigate('/dashboard/oeb/notificaciones/');
    },
    enviarReporte() {
      var self = this;
      var mesNombre = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      self.reporteAsunto = 'Informe OEA — SIMECAL — ' + mesNombre[self.mes] + ' ' + self.anio;
      // Precargar emails de personas OEA
      Oeb.getPersonasConfig().then(function(res) {
        var personas = unwrapDto(res) || [];
        var emails = personas.filter(function(p) { return p.email && p.activo; }).map(function(p) { return p.email; });
        self.reporteEmails = emails.join(', ');
        self.popupReporte = true;
      }).catch(function() { self.popupReporte = true; });
    },
    actualizarAsuntoReporte() {
      var mesNombre = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      if (this.reporteTipo === 'DIARIO') this.reporteAsunto = 'Informe diario OEA — SIMECAL — ' + new Date().toLocaleDateString('es-ES');
      else if (this.reporteTipo === 'SEMANAL') this.reporteAsunto = 'Informe semanal OEA — SIMECAL';
      else this.reporteAsunto = 'Informe OEA — SIMECAL — ' + mesNombre[this.mes] + ' ' + this.anio;
    },
    confirmarEnvioReporte() {
      var self = this;
      var emails = self.reporteEmails.split(',').map(function(e) { return e.trim(); }).filter(function(e) { return e; });
      if (!emails.length) {
        self.$f7.toast.create({ text: 'Introduce al menos un email', position: 'top', closeTimeout: 2000 }).open();
        return;
      }
      var emailsCc = self.reporteCc ? self.reporteCc.split(',').map(function(e) { return e.trim(); }).filter(function(e) { return e; }) : [];
      cerrojoDeLaSesion(self, 'enviandoReporte');
      Oeb.enviarReporte({
        anio: self.anio, mes: self.mes,
        emails: emails, emailsCc: emailsCc, emailsCco: [],
        asunto: self.reporteAsunto,
        tipoReporte: self.reporteTipo,
        origen: 'PRODUCCION'
      }).then(function(res) {
        self.enviandoReporte = false;
        self.popupReporte = false;
        self.$f7.toast.create({ text: unwrapDto(res) || 'Reporte enviado', position: 'top', closeTimeout: 3000 }).open();
      }).catch(function(e) {
        self.enviandoReporte = false;
        self.$f7.toast.create({ text: 'Error al enviar: ' + (e.message || 'desconocido'), position: 'top', closeTimeout: 3000 }).open();
      });
    },
    abrirDetallePersona(persona) {
      var self = this;
      self.personaSel = persona;
      self.objetivoEditable = persona.objetivoDiarioActual || 0;
      self.vacacionesEditable = persona.diasVacaciones || 0;
      self.historialConfig = [];
      self.popupAbierto = true;
      Oeb.getPersona(persona.codigoPersonal).then(function(res) {
        if (unwrapDto(res) && unwrapDto(res).historicoCambios) {
          self.historialConfig = unwrapDto(res).historicoCambios || [];
        }
      }).catch(function() {});
    },
    // #85 · El objetivo va al mes que se estaba mirando, como el resto de acciones de la pantalla:
    // el popup de la persona se queda abierto por encima del selector, así que aquí también cabe un
    // cambio de mes con la ficha vieja todavía debajo.
    guardarObjetivo(persona) {
      var self = this;
      var ref = self.refFicha();
      if (!ref) return self.avisarFichaEnVuelo('No se ha cambiado el objetivo');
      Oeb.cambiarObjetivoDiarioEnFicha(ref.id, persona.codigoPersonal, { objetivoDiario: self.objetivoEditable }).then(function(res) {
        // Y la respuesta tampoco se pinta si para cuando llega la pantalla ya está en otro mes: eso
        // dejaría la ficha del mes anterior debajo del selector nuevo.
        if (!self.aplicarResultado(ref)) return;
        if (unwrapDto(res)) {
          self.ficha = unwrapDto(res);
          var actualizada = self.ficha.personas.find(function(p) { return p.codigoPersonal === persona.codigoPersonal; });
          if (actualizada) { self.personaSel = actualizada; self.objetivoEditable = actualizada.objetivoDiarioActual; }
          self.$f7.toast.create({ text: 'Objetivo actualizado', position: 'top', closeTimeout: 2000 }).open();
        }
      // #164 · El aviso sale aunque la pantalla haya cambiado de mes: lo que no se ha guardado no se
      // ha guardado en ningún mes, y callarlo es justo lo que hacía que se cambiaran objetivos
      // creyendo que quedaban puestos.
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'el objetivo de ' + persona.codigoPersonal, err);
      });
    },
    // #85 · Con dos preguntas seguidas delante, aquí cabe de sobra un cambio de mes antes de que se
    // escriba nada: los días hábiles y su motivo van al mes que se estaba mirando al empezar, o no
    // van a ninguno. Es el mismo descuido que se corrigió en «+ Persona», «Guardar personas del
    // mes» y «Quitar del mes», y no es de personas, pero vive en la misma pantalla.
    editarDiaSemana(semana) {
      var self = this;
      var persona = self.personaSel;
      var ref = self.refFicha();
      if (!ref) return self.avisarFichaEnVuelo('No se ha cambiado nada');
      self.$f7.dialog.prompt('Nuevos días hábiles (S' + semana.semanaNumero + '):', 'Días hábiles',
        function(dias) {
          self.$f7.dialog.prompt('Motivo del cambio:', 'Motivo',
            function(motivo) {
              if (!self.esElMismoMes(ref)) {
                self.$f7.dialog.alert('La pantalla ha cambiado de mes. No se han cambiado los días de nadie.', 'No se ha cambiado nada');
                return;
              }
              Oeb.modificarDiasHabiles(ref.id, persona.codigoPersonal, {
                semanaNumero: semana.semanaNumero,
                diasHabiles: parseInt(dias),
                motivo: motivo || 'Sin motivo'
              }).then(function(res) {
                if (!self.aplicarResultado(ref)) return;
                if (unwrapDto(res)) {
                  self.ficha = unwrapDto(res);
                  var actualizada = self.ficha.personas.find(function(p) { return p.codigoPersonal === persona.codigoPersonal; });
                  if (actualizada) self.personaSel = actualizada;
                  self.$f7.toast.create({ text: 'Días actualizados', position: 'top', closeTimeout: 2000 }).open();
                }
              }).catch(function(err) {
                avisoNoGuardado(self.$f7, 'los días hábiles de ' + persona.codigoPersonal, err);
              });
            }, function() {}, 'Cambio de días'
          );
        }, function() {}, semana.diasHabiles + ''
      );
    },
    verNotaDias(semana) {
      if (semana.modificacion) {
        this.$f7.dialog.alert('De ' + semana.modificacion.diasAnterior + ' a ' + semana.modificacion.diasNuevo + ' días\nMotivo: ' + semana.modificacion.motivo + '\nPor: ' + semana.modificacion.usuario + '\nFecha: ' + (semana.modificacion.fecha ? new Date(semana.modificacion.fecha).toLocaleDateString('es-ES') : ''), 'Nota de modificación');
      }
    },
    obtenerRangoSemana(semanaNumero) {
      if (!this.ficha || !this.ficha.calendario) return '';
      var sem = this.ficha.calendario.semanas.find(function(s) { return s.numero === semanaNumero; });
      if (!sem) return '';
      var match = sem.etiqueta.match(/\((\d+-\d+)\)/);
      return match ? match[1] : '';
    },
    calcularObjMensual() {
      if (!this.personaSel || !this.personaSel.semanas) return 0;
      var obj = this.objetivoEditable || 0;
      return this.personaSel.semanas.reduce(function(sum, s) { return sum + (obj * (s.diasHabiles || 0)); }, 0);
    },
    guardarClasificacion(persona, nueva) {
      var self = this;
      var ref = self.refFicha();
      if (!ref) return self.avisarFichaEnVuelo('No se ha cambiado la clasificación');
      Oeb.cambiarClasificacionEnFicha(ref.id, persona.codigoPersonal, { clasificacion: nueva }).then(function(res) {
        if (!self.aplicarResultado(ref)) return;
        if (unwrapDto(res)) {
          self.ficha = unwrapDto(res);
          var actualizada = self.ficha.personas.find(function(p) { return p.codigoPersonal === persona.codigoPersonal; });
          if (actualizada) self.personaSel = actualizada;
          self.$f7.toast.create({ text: 'Clasificación actualizada', position: 'top', closeTimeout: 2000 }).open();
        }
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'la clasificación de ' + persona.codigoPersonal, err);
      });
    },
    // #34 · Quitar deja de enseñarla; sus cifras del mes se quedan donde estaban y vuelven si se
    // la añade otra vez. El popup de la persona se cierra: la que tenía abierta ya no está.
    //
    // Se quita del mes que se estaba mirando al pulsar: si al confirmar la pantalla ya está en
    // otro, no se toca ninguno de los dos.
    quitarPersona(persona) {
      var self = this;
      var ref = self.refFicha();
      if (!ref) return self.avisarFichaEnVuelo('No se ha quitado a nadie');
      self.$f7.dialog.confirm('¿Quitar a ' + persona.codigoPersonal + ' de este mes? Deja de verse, pero sus cifras no se borran: si se la vuelve a añadir, siguen ahí.', 'Confirmar', function() {
        if (!self.esElMismoMes(ref)) {
          self.$f7.dialog.alert('La pantalla ha cambiado de mes. No se ha quitado a nadie.', 'No se ha quitado a nadie');
          return;
        }
        Oeb.quitarPersonaDeFicha(ref.id, persona.codigoPersonal).then(function(res) {
          if (!self.esElMismoMes(ref)) return;
          if (unwrapDto(res)) {
            self.popupAbierto = false;
            self.cargarFicha();
          }
        }).catch(function(err) {
          avisoNoGuardado(self.$f7, 'que ' + persona.codigoPersonal + ' deje de verse este mes', err);
        });
      });
    },
    // FORMATEO
    formatImporte(valor) {
      if (valor == null) return '0 €';
      return Math.round(valor).toLocaleString('es-ES') + ' €';
    },
    formatImporteCorto(valor) {
      if (valor == null) return '0';
      return Math.round(valor).toLocaleString('es-ES');
    },
    formatImporteConSigno(valor) {
      if (valor == null) return '0 €';
      var signo = valor >= 0 ? '+' : '';
      return signo + Math.round(valor).toLocaleString('es-ES') + ' €';
    },
    formatPorcentaje(valor) {
      if (valor == null) return '0%';
      return valor.toFixed(1) + '%';
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      var d = new Date(fecha);
      return d.toLocaleDateString('es-ES') + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },
    extraerDias(semana) {
      if (!semana || !semana.etiqueta) return '';
      var match = semana.etiqueta.match(/\((\d+-\d+)\)/);
      return match ? match[1] : '';
    },
    colorProgresionMensual(persona) {
      var resultado = persona.progresionMes || 0;
      var objetivo = persona.objetivoMensual || 0;
      if (!objetivo || objetivo <= 0 || !resultado) return {};
      var pct = (resultado / objetivo) * 100;
      if (pct >= 105) return { background: '#D6EAF8', color: '#1B4F72' };
      if (pct >= 100) return { background: '#D5F5E3', color: '#0E6251' };
      if (pct >= 95) return { background: '#FADBD8', color: '#943126' };
      return { background: '#F1948A', color: '#641E16' };
    },
    colorCeldaSemana(persona, indiceSemana) {
      var resultado = persona.resultadosSemana ? persona.resultadosSemana[indiceSemana] : 0;
      var objetivo = persona.objetivosSemana ? persona.objetivosSemana[indiceSemana] : 0;
      if (!objetivo || objetivo <= 0 || !resultado) return {};
      var pct = (resultado / objetivo) * 100;
      if (pct >= 105) return { background: '#D6EAF8', color: '#1B4F72' };
      if (pct >= 100) return { background: '#D5F5E3', color: '#0E6251' };
      if (pct >= 95) return { background: '#FADBD8', color: '#943126' };
      return { background: '#F1948A', color: '#641E16' };
    },
    calcularDiasHabilesPersona(persona) {
      if (!persona.semanas) return 0;
      return persona.semanas.reduce(function(sum, s) { return sum + (s.diasHabiles || 0); }, 0);
    },
    // === Helpers para KPIs superiores (mismo patron que Planificacion) ===
    getNumIc(cod) {
      return this.numIcData && this.numIcData[cod] != null ? this.numIcData[cod] : 1;
    },
    getHorasDiarias(cod) {
      if (this.horasDiariasData && this.horasDiariasData[cod] != null) return this.horasDiariasData[cod];
      return this.getNumIc(cod) * 8;
    },
    getDesgloseBL(cod) {
      if (!this.desglose || !this.desglose[cod]) return 0;
      return this.desglose[cod].diasBajaLaboral || 0;
    },
    sumaTpcPersona(cod) {
      // En Produccion los resultadosSemana YA son TPC=SI (reparto-ejec con trabCm="S"),
      // equivalente al tpcOriginal de Planificacion.
      if (!this.ficha || !this.ficha.personas) return 0;
      var p = this.ficha.personas.find(function(pp) { return pp.codigoPersonal === cod; });
      return p ? (p.progresionMes || 0) : 0;
    },
    getCompensacionPersona(cod) {
      if (!this.compensacionData || !this.compensacionData[cod]) return 0;
      return this.compensacionData[cod];
    },
    getSemanaParaDia(dia) {
      if (!this.ficha || !this.ficha.calendario || !this.ficha.calendario.semanas) return '?';
      var sems = this.ficha.calendario.semanas;
      for (var i = 0; i < sems.length; i++) {
        var ini = sems[i].fechaInicio; var fin = sems[i].fechaFin;
        if (!ini || !fin) continue;
        var iniParts = ini.split('-'); var finParts = fin.split('-');
        var dIni = parseInt(iniParts[2]); var dFin = parseInt(finParts[2]);
        var mIni = parseInt(iniParts[1]); var mFin = parseInt(finParts[1]);
        if (mIni === this.mes && mFin === this.mes && dia >= dIni && dia <= dFin) return sems[i].numero;
        if (mIni < this.mes && dia <= dFin) return sems[i].numero;
        if (mFin > this.mes && dia >= dIni) return sems[i].numero;
      }
      return '?';
    },
    diaSemanaLabel(dia) {
      if (!dia || !this.anio || !this.mes) return '';
      var d = new Date(this.anio, this.mes - 1, dia);
      var dias = ['Dom', 'Lun', 'Mar', 'Mi\u00e9', 'Jue', 'Vie', 'S\u00e1b'];
      return dias[d.getDay()];
    },
    getDiasRealesSem(cod, idx) {
      if (!this.desglose || !this.desglose[cod] || !this.desglose[cod].diasRealesSem) return 0;
      return this.desglose[cod].diasRealesSem[idx] != null ? this.desglose[cod].diasRealesSem[idx] : 0;
    },
    getColorDiaSemana(cod, idx) {
      var aus = this.ausencias[cod];
      if (!aus || !this.ficha || !this.ficha.calendario) return '';
      var sem = this.ficha.calendario.semanas[idx];
      if (!sem) return '';
      var iniParts = sem.fechaInicio.split('-'); var finParts = sem.fechaFin.split('-');
      var dIni = parseInt(iniParts[2]); var dFin = parseInt(finParts[2]);
      var mIni = parseInt(iniParts[1]); var mFin = parseInt(finParts[1]);
      var hasBaja = false, hasOtra = false;
      for (var i = 0; i < aus.length; i++) {
        var d = aus[i].dia;
        var enSem = (mIni === this.mes && mFin === this.mes) ? (d >= dIni && d <= dFin) :
                    (mIni < this.mes ? d <= dFin : d >= dIni);
        if (!enSem) continue;
        if (aus[i].motivo && aus[i].motivo.toUpperCase().indexOf('BAJA') >= 0) hasBaja = true;
        else hasOtra = true;
      }
      if (hasBaja) return 'dia-baja';
      if (hasOtra) return 'dia-ausencia';
      return '';
    },
    getProdHora(cod) {
      if (!this.ficha || !this.ficha.personas) return 0;
      var p = this.ficha.personas.find(function(pp) { return pp.codigoPersonal === cod; });
      var dr = p ? (p.diasReales || 0) : 0;
      if (dr <= 0) return 0;
      var prodDia = this.sumaTpcPersona(cod) / dr;
      var hd = this.getHorasDiarias(cod);
      return hd > 0 ? Math.round(prodDia / hd) : 0;
    },
    calcularEstadoColor(porcentaje) {
      if (porcentaje == null) return 'MUY_MALO';
      if (porcentaje > 105) return 'MUY_BUENO';
      if (porcentaje >= 100) return 'BUENO';
      if (porcentaje >= 95) return 'MALO';
      return 'MUY_MALO';
    },
    // Instrucciones
    cargarInstrucciones() {
      var self = this;
      Oeb.getInstrucciones('control-cifras-oeb').then(function(res) {
        self.instrucciones = (unwrapDto(res) || []).map(function(i) { i._editando = false; return i; });
      }).catch(function() {});
    },
    inicializarInst() {
      var self = this;
      Oeb.inicializarInstrucciones('control-cifras-oeb').then(function() { self.cargarInstrucciones(); })
        .catch(function(err) { avisoNoGuardado(self.$f7, 'las instrucciones iniciales', err); });
    },
    nuevaInst() {
      var self = this;
      Oeb.crearInstruccion({ pantalla: 'control-cifras-oeb', titulo: 'Nueva instrucción', texto: 'Escribe aquí...', orden: self.instrucciones.length }).then(function(res) {
        if (unwrapDto(res)) { unwrapDto(res)._editando = true; self.instrucciones.push(unwrapDto(res)); self.expandedInst = unwrapDto(res).id; }
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'la instrucción nueva', err);
      });
    },
    guardarInst(inst) {
      var self = this;
      Oeb.actualizarInstruccion(inst.id, { titulo: inst.titulo, texto: inst.texto }).then(function() {
        inst._editando = false;
        self.$f7.toast.create({ text: 'Instrucción guardada', position: 'top', closeTimeout: 2000 }).open();
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'la instrucción «' + inst.titulo + '»', err);
      });
    },
    eliminarInst(inst) {
      var self = this;
      self.$f7.dialog.confirm('¿Eliminar "' + inst.titulo + '"?', 'Eliminar', function() {
        Oeb.eliminarInstruccion(inst.id).then(function() {
          self.instrucciones = self.instrucciones.filter(function(i) { return i.id !== inst.id; });
        }).catch(function(err) {
          avisoNoGuardado(self.$f7, 'el borrado de «' + inst.titulo + '»', err);
        });
      });
    },
    // El orden se reordena en pantalla antes de que el servidor conteste, así que si el guardado
    // falla hay que decirlo y recargar: dejar la lista movida sin que lo esté en el servidor hace
    // creer que el orden nuevo es el que verá el siguiente que entre. Esta recarga vale porque las
    // mutaciones de instrucciones tiran la caché de 60 s del adapter; si no, restauraría la foto
    // anterior a los cambios que sí se guardaron en ese minuto.
    dropInst(idx) {
      const self = this;
      var from = this.draggingInst;
      if (from === null || from === idx) return;
      var item = this.instrucciones.splice(from, 1)[0];
      this.instrucciones.splice(idx, 0, item);
      this.draggingInst = null;
      var ids = this.instrucciones.map(function(i) { return i.id; });
      Oeb.reordenarInstrucciones(ids).catch(function(err) {
        avisoNoGuardado(self.$f7, 'el orden de las instrucciones', err);
        self.cargarInstrucciones();
      });
    },
  }
};
</script>
